<template>
  <div class="c1-main c1-games-page" @click="c1TopTab = null">

    <!-- TOAST NOTIFICATION -->
    <transition name="g1-toast-fade">
      <div v-if="g1Toast" class="g1-toast" :style="{ background: g1Toast.color }">{{ g1Toast.msg }}</div>
    </transition>

    <!-- TOP BAR -->
    <div class="c1-tib" @click="g1ActivePanel = null">
      <div class="c1-tib-side c1-tib-left">
        <div class="c1-tib-user" @click.stop="g1PanelBtnClick()">
          <span class="c1-tib-ini">{{ g1Initials }}</span>
          <span class="c1-tib-udot online"></span>
        </div>
      </div>
      <div class="c1-tib-center">
        <div class="c1-tib-mod-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><line x1="6" y1="12" x2="10" y2="12"/><line x1="8" y1="10" x2="8" y2="14"/><circle cx="15" cy="11" r="1"/><circle cx="17" cy="13" r="1"/><path d="M17 9a4 4 0 0 1 4 4v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a4 4 0 0 1 4-4h10z"/></svg>
          Arcade
        </div>
      </div>
      <div class="c1-tib-side c1-tib-right">
        <!-- earned minutes chip -->
        <div class="g1-credits-chip">⏱ {{ g1Credits }} min</div>
      </div>
    </div>

    <!-- ══ GAMES TOP FILTER STRIP ══ -->
    <div class="c1-top-strip" @click.stop>
      <div class="c1-top-strip-body">

        <!-- TAB ROW -->
        <div class="c1-ts-tab-row">
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'type'}" @click.stop="c1TopTab = c1TopTab === 'type' ? null : 'type'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><line x1="6" y1="12" x2="10" y2="12"/><line x1="8" y1="10" x2="8" y2="14"/><circle cx="15" cy="11" r="1"/><circle cx="17" cy="13" r="1"/></svg>
            <span>Type</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='type' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'mode'}" @click.stop="c1TopTab = c1TopTab === 'mode' ? null : 'mode'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
            <span>Mode</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='mode' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'access'}" @click.stop="c1TopTab = c1TopTab === 'access' ? null : 'access'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            <span>Access</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='access' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'rankings'}" @click.stop="c1TopTab = c1TopTab === 'rankings' ? null : 'rankings'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><polyline points="18 20 18 10"/><polyline points="12 20 12 4"/><polyline points="6 20 6 14"/></svg>
            <span>Rankings</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='rankings' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'charts'}" @click.stop="c1TopTab = c1TopTab === 'charts' ? null : 'charts'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
            <span>Charts</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='charts' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>

        <!-- TYPE DROPDOWN -->
        <div v-show="c1TopTab === 'type'" class="c1-ts-dropdown">
          <div class="c1-fs-section-lbl">Game Type</div>
          <div class="g1-chip-row" style="padding:0 8px 8px;flex-wrap:wrap;display:flex;gap:6px">
            <div class="g1-chip" :class="{ on: g1FilterType === null }" @click.stop="g1FilterType = null; c1TopTab = null">All</div>
            <div v-for="t in g1GameTypes" :key="t" class="g1-chip" :class="{ on: g1FilterType === t }" @click.stop="g1FilterType = g1FilterType === t ? null : t">{{ t }}</div>
          </div>
        </div>

        <!-- MODE DROPDOWN -->
        <div v-show="c1TopTab === 'mode'" class="c1-ts-dropdown">
          <div class="c1-fs-section-lbl">Competition Mode</div>
          <div class="g1-chip-row" style="padding:0 8px 8px;flex-wrap:wrap;display:flex;gap:6px">
            <div v-for="m in ['All-time','Weekly','Shift']" :key="m" class="g1-chip" :class="{ on: g1FilterMode === m }" @click.stop="g1FilterMode = g1FilterMode === m ? null : m">{{ m }}</div>
          </div>
        </div>

        <!-- ACCESS DROPDOWN -->
        <div v-show="c1TopTab === 'access'" class="c1-ts-dropdown">
          <div class="c1-fs-section-lbl">Access</div>
          <div class="c1-fs-toggle" style="margin:0 8px 8px">
            <div class="c1-fs-tog-btn" :class="{ on: g1FilterAccess === 'all' }" @click.stop="g1FilterAccess = 'all'; c1TopTab = null">All Games</div>
            <div class="c1-fs-tog-btn" :class="{ on: g1FilterAccess === 'earned' }" @click.stop="g1FilterAccess = 'earned'; c1TopTab = null">My Earned</div>
          </div>
          <div class="c1-fs-section-lbl">My Rank</div>
          <div class="g1-rank-overview" style="margin:0 8px 8px">
            <div class="g1-rank-overview-inner">
              <span class="g1-rank-num">#{{ g1OverallRank }}</span>
              <span class="g1-rank-sub">overall across all games</span>
            </div>
          </div>
          <div v-if="g1ActiveFilterCount" class="c1-reset-bar" style="margin:6px 8px 4px" @click.stop="g1ResetFilters(); c1TopTab = null">
            <svg viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
            Reset all filters <span class="c1-reset-bar-count">{{ g1ActiveFilterCount }}</span>
          </div>
        </div>

        <!-- RANKINGS DROPDOWN -->
        <div v-show="c1TopTab === 'rankings'" class="c1-ts-dropdown">
          <div class="c1-fs-section-lbl">Global Standing</div>
          <div class="g1-rank-overview" style="margin:0 8px 8px">
            <div class="g1-rank-overview-inner">
              <span class="g1-rank-num">#{{ g1OverallRank }}</span>
              <span class="g1-rank-sub">your global standing</span>
            </div>
            <div class="g1-credits-row">
              <span class="g1-cred-lbl">Balance</span>
              <span class="g1-cred-val">⏱ {{ g1Credits }} min</span>
            </div>
          </div>
          <div class="c1-fs-section-lbl">Per-Game Leaderboards</div>
          <div style="max-height:280px;overflow-y:auto">
            <div v-for="item in g1RankingsGames" :key="'rk-' + item.game.id" class="g1-rk-section">
              <div class="g1-rk-section-hdr"
                @click.stop="g1RankOpenGame = g1RankOpenGame === item.game.id ? null : item.game.id"
                :class="{ open: g1RankOpenGame === item.game.id }">
                <span class="g1-rk-emoji">{{ item.game.emoji }}</span>
                <span class="g1-rk-name">{{ item.game.name }}</span>
                <span class="g1-rk-count">{{ item.entries.length }}</span>
                <svg class="g1-rk-chv" viewBox="0 0 24 24" :style="{ transform: g1RankOpenGame === item.game.id ? 'rotate(180deg)' : '' }"><polyline points="6 9 12 15 18 9"/></svg>
              </div>
              <div v-if="g1RankOpenGame === item.game.id" class="g1-rk-body">
                <div v-if="!item.entries.length" class="g1-empty">No scores yet</div>
                <div v-for="(entry, ei) in item.entries" :key="'rke-' + ei" class="g1-lb-item" :class="{ 'g1-lb-me': g1IsMe(entry.user_id) }">
                  <span class="g1-lb-medal">{{ ei === 0 ? '🥇' : ei === 1 ? '🥈' : ei === 2 ? '🥉' : '#' + (ei + 1) }}</span>
                  <div class="g1-lb-av" :style="{ background: item.game.color }">{{ g1NameInitials(entry.name) }}</div>
                  <div class="g1-lb-info">
                    <div class="g1-lb-name">{{ entry.name }}{{ g1IsMe(entry.user_id) ? ' (you)' : '' }}</div>
                  </div>
                  <div class="g1-lb-score">{{ (entry.score || 0).toLocaleString() }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CHARTS DROPDOWN -->
        <div v-show="c1TopTab === 'charts'" class="c1-ts-dropdown">
          <div class="c1-fs-section-lbl">Global Top 10</div>
          <div style="max-height:260px;overflow-y:auto;padding:0 8px 8px">
            <div v-for="(entry, idx) in g1Top10" :key="'top10-' + idx" class="g1-lb-row">
              <div class="g1-lb-rank" :class="idx === 0 ? 'rank-gold' : idx === 1 ? 'rank-silver' : idx === 2 ? 'rank-bronze' : 'rank-default'">#{{ idx + 1 }}</div>
              <div class="g1-lb-av">{{ g1NameInitials(entry.name) }}</div>
              <div class="g1-lb-info">
                <div class="g1-lb-name">{{ entry.name }}</div>
                <div class="g1-lb-game-tag">{{ entry.game }}</div>
              </div>
              <div class="g1-lb-score">{{ (entry.score || 0).toLocaleString() }}</div>
            </div>
            <div v-if="!g1Top10.length" class="g1-empty">No scores yet — be the first!</div>
          </div>
        </div>

        <div class="c1-nm-div"></div>
        <c1-mod-calendar :items="g1Games" dateField="created_at" itemLabel="sessions" style="flex-shrink:0" />

      </div>
    </div><!-- /c1-top-strip -->

    <!-- PANEL BACKDROP -->
    <transition name="c1-bd-fade">
      <div v-if="g1ActivePanel || g1DetailGame || g1AdminPanelOpen" class="c1-panel-backdrop" @click.stop="g1ActivePanel = null; g1DetailGame = null; g1AdminPanelOpen = false"></div>
    </transition>

    <!-- ── UNIFIED PANEL ── -->
    <div class="c1-panel" :class="{ 'c1-panel--open': g1PanelIsOpen }" @click.stop>
      <div class="c1-panel-track" :class="{ 'at-content': g1PanelAtContent }">
        <!-- Screen 0: Nav -->
        <div class="c1-panel-screen">

          <!-- ── USER STRIP ── -->
          <div class="c1-nav-user-strip">
            <div class="c1-nav-av">{{ c1UserInitials }}</div>
            <div class="c1-nav-uinfo">
              <div class="c1-nav-uname">{{ c1UserFullName }}</div>
              <div class="c1-nav-urole">{{ c1RoleLabel }}</div>
            </div>
            <button class="c1-nav-logout-btn" @click.stop="c1Logout()" title="Log out">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
            </button>
          </div>

          <!-- ── TIMEZONE BAR ── -->
          <div class="c1-nav-tz-bar">
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇬🇧</span><span class="c1-nav-tz-time">{{ c1TzUK }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇮🇱</span><span class="c1-nav-tz-time">{{ c1TzIL }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🏝</span><span class="c1-nav-tz-time">{{ c1TzCB }}</span></div>
          </div>

          <!-- ── NAVIGATE MODE: all pages ── -->
          <div v-if="c1NavMode === 'navigate'" class="c1-sl-body" style="padding:6px 0 12px">
            <div class="c1-psel-sub c1-psel-sub-back" @click.stop="c1NavMode = 'panels'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="15 18 9 12 15 6"/></svg>
              <span class="c1-psel-sub-lbl">Arcade</span>
              <span class="c1-nav-x-btn" @click.stop="g1ActivePanel = null"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:15px;height:15px;display:block"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span>
            </div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">CRM</div>
            <router-link class="c1-psel-sub" to="/clients1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Clients</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/tasks1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Tasks</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/stats1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Statistics</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/chat1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Chat</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/communications1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Communications</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/affiliation1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Affiliation</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Sales</div>
            <router-link class="c1-psel-sub" to="/finance1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Finance</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/shifts1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Shifts</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/games1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Games</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Team</div>
            <router-link class="c1-psel-sub" to="/users1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Users</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/brokers1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Brokers</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/security1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Security</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Admin</div>
            <router-link class="c1-psel-sub" to="/quiz1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Quiz</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/instruction1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Instructions</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/settings1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Settings</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/profile1" @click.native="g1ActivePanel = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">My Profile</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
          </div>

          <!-- ── PANELS MODE ── -->
          <div v-else class="c1-sl-body" style="padding:6px 0 12px">
            <!-- Navigate row -->
            <div class="c1-psel-sub c1-psel-sub-navigate" @click.stop="c1NavMode = 'navigate'">
              <span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span>
              <span class="c1-psel-sub-lbl" style="font-weight:600;color:var(--c1-dp)">Arcade</span>
              <span class="c1-psel-sub-hint">Go to another page</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-sub" @click.stop="g1SelectPanel('filters')">
              <span class="c1-psel-sub-dot">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
              </span>
              <span class="c1-psel-sub-lbl">Filters</span>
              <span v-if="g1ActiveFilterCount" class="c1-psel-sub-hint">{{ g1ActiveFilterCount }} active</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" @click.stop="g1SelectPanel('charts')">
              <span class="c1-psel-sub-dot">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
              </span>
              <span class="c1-psel-sub-lbl">Charts</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" @click.stop="g1SelectPanel('calendar')">
              <span class="c1-psel-sub-dot">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              </span>
              <span class="c1-psel-sub-lbl">Calendar</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" @click.stop="g1SelectPanel('rankings')">
              <span class="c1-psel-sub-dot">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><polyline points="18 20 18 10"/><polyline points="12 20 12 4"/><polyline points="6 20 6 14"/></svg>
              </span>
              <span class="c1-psel-sub-lbl">Rankings</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" @click.stop="g1SelectPanel('viki')">
              <span class="c1-psel-sub-dot">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
              </span>
              <span class="c1-psel-sub-lbl">Viki</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
          </div>
        </div>
        <!-- Screen 1: Content -->
        <div class="c1-panel-screen">
          <div class="c1-panel-hdr-bar">
            <div class="c1-panel-back-btn" @click="g1SelectPanel('nav')">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </div>
            <span class="c1-panel-hdr-ttl">{{ g1ActivePanelLabel }}</span>
            <div class="c1-panel-back-btn" @click="g1ActivePanel = null">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <!-- Filters -->
          <template v-if="g1PanelActiveContent === 'filters'">
            <div class="c1-sl-body">
              <!-- Game type chips -->
              <div class="c1-fs-section-lbl">Game Type</div>
              <div class="g1-chip-row">
                <div
                  class="g1-chip"
                  :class="{ on: g1FilterType === null }"
                  @click="g1FilterType = null"
                >All</div>
                <div
                  v-for="t in g1GameTypes"
                  :key="t"
                  class="g1-chip"
                  :class="{ on: g1FilterType === t }"
                  @click="g1FilterType = g1FilterType === t ? null : t"
                >{{ t }}</div>
              </div>
              <!-- Competition mode -->
              <div class="c1-fs-section-lbl" style="margin-top:14px">Competition Mode</div>
              <div class="g1-chip-row">
                <div
                  v-for="m in ['All-time','Weekly','Shift']"
                  :key="m"
                  class="g1-chip"
                  :class="{ on: g1FilterMode === m }"
                  @click="g1FilterMode = g1FilterMode === m ? null : m"
                >{{ m }}</div>
              </div>
              <!-- Access -->
              <div class="c1-fs-section-lbl" style="margin-top:14px">Access</div>
              <div class="g1-chip-row">
                <div
                  class="g1-chip"
                  :class="{ on: g1FilterAccess === 'all' }"
                  @click="g1FilterAccess = 'all'"
                >All Games</div>
                <div
                  class="g1-chip"
                  :class="{ on: g1FilterAccess === 'earned' }"
                  @click="g1FilterAccess = 'earned'"
                >My Earned</div>
              </div>
              <!-- My overall rank chip -->
              <div class="c1-fs-section-lbl" style="margin-top:14px">My Rank</div>
              <div class="g1-rank-overview">
                <div class="g1-rank-overview-inner">
                  <span class="g1-rank-num">#{{ g1OverallRank }}</span>
                  <span class="g1-rank-sub">overall across all games</span>
                </div>
              </div>
              <!-- Reset -->
              <div v-if="g1ActiveFilterCount" class="c1-reset-bar" @click="g1ResetFilters()">
                <svg viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
                Reset all filters
                <span class="c1-reset-bar-count">{{ g1ActiveFilterCount }}</span>
              </div>
            </div>
          </template>
          <!-- Charts -->
          <template v-if="g1PanelActiveContent === 'charts'">
            <div class="c1-sl-body">
              <!-- Section 1: Global Top 10 -->
              <div class="g1-chart-ttl">🏆 Global Top 10</div>
              <div class="g1-chart-block">
                <div
                  v-for="(entry, idx) in g1Top10"
                  :key="'top10-' + idx"
                  class="g1-lb-row"
                >
                  <div
                    class="g1-lb-rank"
                    :class="idx === 0 ? 'rank-gold' : idx === 1 ? 'rank-silver' : idx === 2 ? 'rank-bronze' : 'rank-default'"
                  >#{{ idx + 1 }}</div>
                  <div class="g1-lb-av">{{ g1NameInitials(entry.name) }}</div>
                  <div class="g1-lb-info">
                    <div class="g1-lb-name">{{ entry.name }}</div>
                    <div class="g1-lb-game-tag">{{ entry.game }}</div>
                  </div>
                  <div class="g1-lb-bar-wrap">
                    <div
                      class="g1-lb-bar-fill"
                      :class="idx === 0 ? 'bar-gold' : idx === 1 ? 'bar-silver' : idx === 2 ? 'bar-bronze' : 'bar-default'"
                      :style="{ width: g1LbBarPct(entry.score) + '%' }"
                    ></div>
                  </div>
                  <div class="g1-lb-score">{{ (entry.score || 0).toLocaleString() }}</div>
                </div>
                <div v-if="!g1Top10.length" class="g1-empty">No scores yet — be the first!</div>
              </div>
              <!-- Section 2: Play Frequency -->
              <div class="g1-chart-ttl" style="margin-top:20px">📊 Play Frequency</div>
              <div class="g1-chart-block">
                <div
                  v-for="game in g1Games"
                  :key="'freq-' + game.id"
                  class="g1-freq-row"
                >
                  <span class="g1-freq-emoji">{{ game.emoji }}</span>
                  <span class="g1-freq-name">{{ game.name }}</span>
                  <div class="g1-lb-bar-wrap">
                    <div
                      class="g1-lb-bar-fill bar-default"
                      :style="{ width: g1FreqBarPct(game.id) + '%', background: game.color }"
                    ></div>
                  </div>
                  <span class="g1-freq-count">{{ g1PlayFreq(game.id) }}x</span>
                </div>
              </div>
              <!-- Section 3: My Balance -->
              <div class="g1-chart-ttl" style="margin-top:20px">⏱ My Balance</div>
              <div class="g1-chart-block">
                <div class="g1-balance-big">{{ g1Credits }} <span class="g1-balance-unit">min</span></div>
                <div class="g1-balance-breakdown">
                  <div class="g1-bb-row">
                    <span>From deposits</span>
                    <span>{{ g1CreditsBreakdown.deposits }} min</span>
                  </div>
                  <div class="g1-bb-row">
                    <span>From calls</span>
                    <span>{{ g1CreditsBreakdown.calls }} min</span>
                  </div>
                  <div class="g1-bb-row">
                    <span>From attendance</span>
                    <span>{{ g1CreditsBreakdown.attendance }} min</span>
                  </div>
                </div>
              </div>
              <!-- Section 4: Weekly Sprint -->
              <div class="g1-chart-ttl" style="margin-top:20px">🏃 Weekly Sprint</div>
              <div class="g1-chart-block">
                <div class="g1-sprint-countdown">
                  Next Monday in <strong>{{ g1SprintCountdown }}</strong>
                </div>
                <div
                  v-for="game in g1Games"
                  :key="'sprint-' + game.id"
                  class="g1-sprint-row"
                >
                  <span class="g1-sprint-emoji">{{ game.emoji }}</span>
                  <span class="g1-sprint-name">{{ game.name }}</span>
                  <span class="g1-sprint-leader">{{ g1SprintLeader(game.id) }}</span>
                  <span class="g1-sprint-score">{{ g1SprintScore(game.id) }}</span>
                </div>
                <div v-if="!g1WeeklySprint.length" class="g1-empty">Sprint data loading...</div>
              </div>
            </div>
          </template>
          <!-- Calendar -->
          <template v-if="g1PanelActiveContent === 'calendar'">
            <div class="c1-sl-body">
              <div class="g1-cal-grid">
                <div
                  v-for="(day, idx) in g1WeekDays"
                  :key="'cal-' + idx"
                  class="g1-cal-day"
                  :class="{ 'g1-cal-today': g1IsToday(day.date), 'g1-cal-has-play': g1DayHasPlay(day.date) }"
                  @click="g1CalDayClick(day)"
                >
                  <div class="g1-cal-day-label">{{ day.label }}</div>
                  <div class="g1-cal-day-num">{{ day.dayNum }}</div>
                  <div v-if="g1DayHasPlay(day.date)" class="g1-cal-dot"></div>
                </div>
              </div>
              <!-- Day detail popup -->
              <div v-if="g1CalSelectedDay" class="g1-cal-detail">
                <div class="g1-cal-detail-hdr">{{ g1CalSelectedDay.label }}, {{ g1CalSelectedDay.dayNum }}</div>
                <div
                  v-for="(entry, ei) in g1DayEntries(g1CalSelectedDay.date)"
                  :key="'cde-' + ei"
                  class="g1-cal-entry"
                >
                  <span class="g1-cal-entry-emoji">{{ g1GameEmoji(entry.game_id) }}</span>
                  <span class="g1-cal-entry-name">{{ entry.player_name }}</span>
                  <span class="g1-cal-entry-score">{{ entry.score }}</span>
                </div>
                <div v-if="!g1DayEntries(g1CalSelectedDay.date).length" class="g1-empty">No plays this day</div>
              </div>
            </div>
          </template>
          <!-- Rankings -->
          <template v-if="g1PanelActiveContent === 'rankings'">
            <div class="c1-sl-body">
              <!-- My overall rank banner -->
              <div class="g1-rank-overview" style="margin: 10px 14px 0">
                <div class="g1-rank-overview-inner">
                  <span class="g1-rank-num">#{{ g1OverallRank }}</span>
                  <span class="g1-rank-sub">your global standing</span>
                </div>
                <div class="g1-credits-row">
                  <span class="g1-cred-lbl">Balance</span>
                  <span class="g1-cred-val">⏱ {{ g1Credits }} min</span>
                </div>
              </div>
              <!-- Per-game leaderboards (accordion) -->
              <div
                v-for="item in g1RankingsGames"
                :key="'rk-' + item.game.id"
                class="g1-rk-section"
              >
                <div
                  class="g1-rk-section-hdr"
                  @click="g1RankOpenGame = g1RankOpenGame === item.game.id ? null : item.game.id"
                  :class="{ open: g1RankOpenGame === item.game.id }"
                >
                  <span class="g1-rk-emoji">{{ item.game.emoji }}</span>
                  <span class="g1-rk-name">{{ item.game.name }}</span>
                  <span class="g1-rk-tag" :style="{ color: item.game.color }">{{ item.game.type }}</span>
                  <span class="g1-rk-count">{{ item.entries.length }}</span>
                  <svg class="g1-rk-chv" viewBox="0 0 24 24" :style="{ transform: g1RankOpenGame === item.game.id ? 'rotate(180deg)' : '' }"><polyline points="6 9 12 15 18 9"/></svg>
                </div>
                <div v-if="g1RankOpenGame === item.game.id" class="g1-rk-body">
                  <div v-if="!item.entries.length" class="g1-empty">No scores yet</div>
                  <div
                    v-for="(entry, ei) in item.entries"
                    :key="'rke-' + ei"
                    class="g1-lb-item"
                    :class="{ 'g1-lb-me': g1IsMe(entry.user_id) }"
                  >
                    <span class="g1-lb-medal">{{ ei === 0 ? '🥇' : ei === 1 ? '🥈' : ei === 2 ? '🥉' : '#' + (ei + 1) }}</span>
                    <div class="g1-lb-av" :style="{ background: item.game.color }">{{ g1NameInitials(entry.name) }}</div>
                    <div class="g1-lb-info">
                      <div class="g1-lb-name">
                        <span class="g1-team-dot" :style="{ background: g1TeamDotColor(entry) }" v-if="g1EntryTeamId(entry)"></span>
                        {{ entry.name }}{{ g1IsMe(entry.user_id) ? ' (you)' : '' }}
                      </div>
                      <div class="g1-lb-date">{{ g1FormatDate(entry.date) }}</div>
                    </div>
                    <div class="g1-lb-score">{{ (entry.score || 0).toLocaleString() }}</div>
                    <button
                      v-if="!g1IsMe(entry.user_id)"
                      class="g1-challenge-mini-btn"
                      @click.stop="g1QuickChallenge(entry, item.game)"
                      title="Challenge"
                    >⚔️</button>
                  </div>
                  <div class="g1-rk-play-row">
                    <button class="g1-rk-play-btn" :style="{ borderColor: item.game.color, color: item.game.color }" @click="g1PlayGame(item.game)">
                      {{ g1CanPlay(item.game.id) ? '▶ Play now' : '⏱ Earn time' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- Viki -->
          <template v-if="g1PanelActiveContent === 'viki'">
            <div class="c1-sl-body">
              <div
                v-for="(msg, mi) in g1VikiMessages"
                :key="'vm-' + mi"
                class="g1-viki-msg"
                :class="{ 'g1-viki-unread': !msg.read }"
              >
                <div class="g1-viki-av">{{ g1NameInitials(msg.from_name) }}</div>
                <div class="g1-viki-body">
                  <div class="g1-viki-from">{{ msg.from_name }}</div>
                  <div class="g1-viki-text">{{ msg.text }}</div>
                  <div class="g1-viki-time">{{ g1FormatTime(msg.created_at) }}</div>
                </div>
              </div>
              <div v-if="!g1VikiMessages.length" class="g1-empty">No messages yet</div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- ── GAME DETAIL DRAWER (left) ── -->
    <div
      class="c1-panel g1-detail-panel"
      :class="{ 'c1-panel--open': g1DetailGame !== null }"
    >
      <div class="c1-panel-hdr-bar">
        <span class="g1-detail-emoji">{{ g1DetailGame && g1DetailGame.emoji }}</span>
        <span class="c1-panel-hdr-ttl">{{ g1DetailGame && g1DetailGame.name }}</span>
        <div class="c1-collapse-btn" @click="g1DetailGame = null">
          <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </div>
      </div>
      <div v-if="g1DetailGame" class="c1-sl-body">
        <!-- Leaderboard mode toggle -->
        <div class="g1-lb-mode-row">
          <div
            class="g1-lb-mode-btn"
            :class="{ on: g1LeaderboardMode === 'individual' }"
            @click="g1LeaderboardMode = 'individual'"
          >Individual</div>
          <div
            class="g1-lb-mode-btn"
            :class="{ on: g1LeaderboardMode === 'team' }"
            @click="g1LeaderboardMode = 'team'"
          >Team Battle</div>
        </div>

        <!-- Leaderboard tabs (individual mode only) -->
        <div v-if="g1LeaderboardMode === 'individual'" class="g1-tab-row">
          <div
            v-for="tab in ['All-time','Weekly','Shift']"
            :key="tab"
            class="g1-tab"
            :class="{ on: g1DetailTab === tab }"
            @click="g1DetailTab = tab"
          >{{ tab }}</div>
        </div>

        <!-- Individual Leaderboard list -->
        <div v-if="g1LeaderboardMode === 'individual'" class="g1-lb-list">
          <div
            v-for="(entry, ei) in g1DetailLeaderboard"
            :key="'dl-' + ei"
            class="g1-lb-item"
            :class="{ 'g1-lb-me': g1IsMe(entry.user_id) }"
          >
            <span class="g1-lb-medal">{{ ei === 0 ? '🥇' : ei === 1 ? '🥈' : ei === 2 ? '🥉' : '#' + (ei + 1) }}</span>
            <div class="g1-lb-av">{{ g1NameInitials(entry.name) }}</div>
            <div class="g1-lb-info">
              <div class="g1-lb-name">
                <span
                  class="g1-team-dot"
                  :style="{ background: g1TeamDotColor(entry) }"
                  v-if="g1EntryTeamId(entry)"
                ></span>
                {{ entry.name }}
              </div>
              <div class="g1-lb-date">{{ g1FormatDate(entry.date) }}</div>
            </div>
            <div class="g1-lb-score">{{ (entry.score || 0).toLocaleString() }}</div>
          </div>
          <!-- My position separator if outside top 10 -->
          <template v-if="g1MyDetailPosition > 10 && g1MyDetailEntry">
            <div class="g1-lb-sep">· · ·</div>
            <div class="g1-lb-item g1-lb-me">
              <span class="g1-lb-medal">#{{ g1MyDetailPosition }}</span>
              <div class="g1-lb-av">{{ g1Initials }}</div>
              <div class="g1-lb-info">
                <div class="g1-lb-name">{{ g1UserName }} (me)</div>
                <div class="g1-lb-date">{{ g1FormatDate(g1MyDetailEntry.date) }}</div>
              </div>
              <div class="g1-lb-score">{{ (g1MyDetailEntry.score || 0).toLocaleString() }}</div>
            </div>
          </template>
          <div v-if="!g1DetailLeaderboard.length" class="g1-empty">No scores for this period</div>
        </div>

        <!-- Team Battle view -->
        <div v-if="g1LeaderboardMode === 'team'" class="g1-team-battle">
          <!-- Two team panels side by side -->
          <div class="g1-tb-panels">
            <!-- Team 1 -->
            <div class="g1-tb-panel g1-tb-panel-t1">
              <div class="g1-tb-header">
                <span class="g1-tb-emoji">⚡</span>
                <span class="g1-tb-name">Team 1</span>
                <span v-if="g1BattleWinner === 1" class="g1-tb-crown">👑</span>
              </div>
              <div class="g1-tb-total">{{ g1TeamScores.team1.total.toLocaleString() }}</div>
              <div class="g1-tb-members">
                <div
                  v-for="(m, mi) in g1TeamScores.team1.memberList"
                  :key="'t1m-' + mi"
                  class="g1-tb-member"
                >
                  <span class="g1-tb-member-name">{{ m.name }}</span>
                  <span class="g1-tb-member-score">{{ (m.score || 0).toLocaleString() }}</span>
                </div>
                <div v-if="!g1TeamScores.team1.memberList.length" class="g1-empty" style="font-size:10px;padding:6px 0">No scores yet</div>
              </div>
            </div>
            <!-- Team 2 -->
            <div class="g1-tb-panel g1-tb-panel-t2">
              <div class="g1-tb-header">
                <span v-if="g1BattleWinner === 2" class="g1-tb-crown">👑</span>
                <span class="g1-tb-name">Team 2</span>
                <span class="g1-tb-emoji">🔥</span>
              </div>
              <div class="g1-tb-total">{{ g1TeamScores.team2.total.toLocaleString() }}</div>
              <div class="g1-tb-members">
                <div
                  v-for="(m, mi) in g1TeamScores.team2.memberList"
                  :key="'t2m-' + mi"
                  class="g1-tb-member g1-tb-member-r"
                >
                  <span class="g1-tb-member-score">{{ (m.score || 0).toLocaleString() }}</span>
                  <span class="g1-tb-member-name">{{ m.name }}</span>
                </div>
                <div v-if="!g1TeamScores.team2.memberList.length" class="g1-empty" style="font-size:10px;padding:6px 0">No scores yet</div>
              </div>
            </div>
          </div>

          <!-- Battle Bar -->
          <div class="g1-battle-bar-wrap">
            <span class="g1-bb-label g1-bb-l1">⚡ Team 1</span>
            <div class="g1-bb-track">
              <div class="g1-bb-fill-t1" :style="{ width: g1BattleBarPct.t1 + '%' }">
                <span class="g1-bb-pct" v-if="g1BattleBarPct.t1 > 12">{{ g1BattleBarPct.t1 }}%</span>
              </div>
              <div class="g1-bb-fill-t2" :style="{ width: g1BattleBarPct.t2 + '%' }">
                <span class="g1-bb-pct g1-bb-pct-r" v-if="g1BattleBarPct.t2 > 12">{{ g1BattleBarPct.t2 }}%</span>
              </div>
            </div>
            <span class="g1-bb-label g1-bb-l2">🔥 Team 2</span>
          </div>
        </div>

        <!-- Score history -->
        <div class="c1-fs-section-lbl" style="margin-top:16px">My Score History</div>
        <div class="g1-history-list">
          <div
            v-for="(h, hi) in g1MyScoreHistory"
            :key="'hist-' + hi"
            class="g1-history-row"
          >
            <span class="g1-history-date">{{ g1FormatDate(h.date) }}</span>
            <span class="g1-history-score">{{ (h.score || 0).toLocaleString() }}</span>
          </div>
          <div v-if="!g1MyScoreHistory.length" class="g1-empty">No personal history yet</div>
        </div>

        <!-- Challenge button -->
        <div class="g1-challenge-section">
          <div class="c1-fs-section-lbl">Challenge an Agent</div>
          <div class="g1-challenge-row">
            <select class="g1-challenge-select" v-model="g1ChallengeTarget">
              <option value="">Select agent...</option>
              <option
                v-for="agent in g1AgentList"
                :key="agent.id"
                :value="agent.id"
              >{{ agent.name }}</option>
            </select>
            <button
              class="c1-btn-primary"
              @click="g1SendChallenge"
              :disabled="!g1ChallengeTarget"
            >Challenge</button>
          </div>
        </div>
      </div><!-- /c1-sl-body g1-detail-panel -->
    </div><!-- /g1-detail-panel -->

    <!-- ── ADMIN / TOURNAMENT LEFT DRAWER ── -->
    <div
      class="c1-panel g1-admin-panel"
      :class="{ 'c1-panel--open': g1AdminPanelOpen }"
    >
      <div class="c1-panel-hdr-bar">
        <svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
        <span class="c1-panel-hdr-ttl">{{ g1IsAdminRole ? 'Admin Panel' : 'Tournaments' }}</span>
        <div class="c1-collapse-btn" @click="g1AdminPanelOpen = false">
          <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </div>
      </div>
      <div class="c1-sl-body">

        <!-- ADMIN: game toggles -->
        <template v-if="g1IsAdminRole">
          <div class="c1-fs-section-lbl">Enable / Disable Games</div>
          <div
            v-for="game in g1Games"
            :key="'adm-' + game.id"
            class="g1-admin-game-row"
          >
            <span class="g1-admin-emoji">{{ game.emoji }}</span>
            <span class="g1-admin-name">{{ game.name }}</span>
            <label class="g1-toggle">
              <input
                type="checkbox"
                :checked="g1EnabledGames.includes(game.id)"
                @change="g1ToggleGameEnabled(game.id)"
              />
              <span class="g1-toggle-slider"></span>
            </label>
          </div>

          <!-- Grant bonus minutes -->
          <div class="c1-fs-section-lbl" style="margin-top:18px">Grant Bonus Minutes</div>
          <div class="g1-grant-form">
            <select class="g1-challenge-select" v-model="g1GrantTarget">
              <option value="">Select user...</option>
              <option
                v-for="agent in g1AgentList"
                :key="'ga-' + agent.id"
                :value="agent.id"
              >{{ agent.name }}</option>
            </select>
            <input
              class="g1-grant-input"
              type="number"
              min="1"
              max="999"
              placeholder="Minutes"
              v-model.number="g1GrantMinutes"
            />
            <input
              class="g1-grant-input"
              type="text"
              placeholder="Reason"
              v-model="g1GrantReason"
            />
            <button
              class="c1-btn-primary"
              @click="g1SubmitGrant"
              :disabled="!g1GrantTarget || !g1GrantMinutes"
            >Grant</button>
          </div>
        </template>

        <!-- Active tournaments -->
        <div class="c1-fs-section-lbl" :style="g1IsAdminRole ? 'margin-top:18px' : ''">Active Tournaments</div>
        <div
          v-for="(t, ti) in g1Tournaments"
          :key="'t-' + ti"
          class="c1-box g1-tournament-card"
        >
          <div class="g1-t-name">{{ t.name }}</div>
          <div class="g1-t-end">Ends: {{ g1FormatDate(t.end_date) }}</div>
          <div class="g1-t-standing">Your position: #{{ t.my_rank || '—' }}</div>
        </div>
        <div v-if="!g1Tournaments.length" class="g1-empty">No active tournaments</div>

        <!-- My achievements -->
        <div class="c1-fs-section-lbl" style="margin-top:18px">My Achievements</div>
        <div class="g1-achievements-grid">
          <div
            v-for="(ach, ai) in g1Achievements"
            :key="'ach-' + ai"
            class="g1-ach-badge"
            :title="ach.description"
          >
            <span class="g1-ach-icon">{{ ach.icon }}</span>
            <span class="g1-ach-name">{{ ach.name }}</span>
          </div>
          <div v-if="!g1Achievements.length" class="g1-empty" style="grid-column:1/-1">No achievements yet</div>
        </div>

      </div>
    </div>

    <!-- ── FULLSCREEN GAME OVERLAY ── -->
    <div class="g1-game-overlay" v-if="g1ActiveGame">
      <div class="g1-overlay-header">
        <div class="g1-overlay-title">
          <span>{{ g1ActiveGame.emoji }}</span>
          <span>{{ g1ActiveGame.name }}</span>
        </div>
        <div class="c1-hp"></div>
        <span v-if="g1LiveScore" class="g1-score-live">Score: {{ g1LiveScore.toLocaleString() }}</span>
        <span class="g1-credits-live">⏱ {{ g1CreditCountdown }} min left</span>
        <button class="g1-close-btn" @click="g1HandleGameOver(g1LiveScore)">✓ Save &amp; Close</button>
        <button class="g1-close-btn" style="margin-left:4px;background:transparent;border-color:rgba(255,255,255,.2);color:#666;" @click="g1CloseGame">✕ Discard</button>
      </div>
      <div class="g1-game-frame">
        <div class="g1-game-scaler">
        <component
          v-if="g1GameComponent"
          :is="g1GameComponent"
          @score-update="g1HandleScoreUpdate"
          @game-over="g1HandleGameOver"
        />
        </div>
        <div v-if="!g1GameComponent" class="g1-coming-soon">
          <div style="font-size:3.5rem;margin-bottom:16px">{{ g1ActiveGame.emoji }}</div>
          <div style="font-size:1.1rem;font-weight:700;color:#fff;margin-bottom:6px">{{ g1ActiveGame.name }}</div>
          <div style="color:rgba(255,255,255,.45);font-size:12px;background:rgba(255,255,255,.08);padding:6px 16px;border-radius:20px;">🚧 Coming soon</div>
        </div>
      </div>
    </div>

    <!-- ── MAIN CONTENT ── -->
    <div class="g1-content">

      <!-- Header bar with title + admin toggle -->
      <div class="g1-content-hdr">
        <div class="g1-content-hdr-left">
          <span class="g1-content-title">🎮 Arcade</span>
          <span class="g1-content-sub">{{ g1FilteredGames.length }} games available</span>
        </div>
        <div class="g1-content-hdr-right">
          <button
            v-if="g1IsAdminRole"
            class="c1-tib-btn"
            :class="{ on: g1AdminPanelOpen }"
            @click="g1AdminPanelOpen = !g1AdminPanelOpen"
          >
            <svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            Admin
          </button>
        </div>
      </div>

      <!-- Loading state -->
      <div v-if="g1Loading" class="g1-loading">
        <div class="g1-spinner"></div>
        <span>Loading games...</span>
      </div>

      <!-- Game grid -->
      <div v-else class="g1-game-grid">
        <div
          v-for="game in g1FilteredGames"
          :key="'game-' + game.id"
          class="c1-box g1-game-card"
          @click="g1OpenGameDetail(game)"
        >
          <div class="g1-card-top" :style="{ background: game.color + '12' }">
            <div class="g1-game-emoji">{{ game.emoji }}</div>
            <div class="g1-game-name">{{ game.name }}</div>
            <div class="g1-game-type-tag" :style="{ borderColor: game.color, color: game.color }">{{ game.type }}</div>
          </div>
          <div class="g1-card-body">
            <!-- Mini leaderboard: top 3 with names -->
            <div v-if="g1CardTop3(game.id).length" class="g1-mini-lb">
              <div
                v-for="entry in g1CardTop3(game.id)"
                :key="entry.medal"
                class="g1-mini-lb-row"
              >
                <span class="g1-mini-medal">{{ entry.medal }}</span>
                <span class="g1-mini-name">{{ entry.name }}</span>
                <span class="g1-mini-score">{{ entry.score.toLocaleString() }}</span>
              </div>
            </div>
            <!-- No scores yet -->
            <div v-else class="g1-no-scores">No scores yet — be first! 🚀</div>

            <!-- My rank + beat-it badge -->
            <div class="g1-card-footer">
              <div class="g1-rank-chip" :class="g1RankClass(game.id)">
                #{{ g1MyRank(game.id) || '?' }} of {{ g1PlayerCount(game.id) }}
              </div>
              <div v-if="g1IsNearRecord(game.id)" class="g1-beat-it">Beat it! 🔥</div>
              <div v-else-if="g1MyBest(game.id) !== null" class="g1-my-best-chip">
                You: {{ g1MyBest(game.id).toLocaleString() }}
              </div>
            </div>

            <button
              class="c1-btn-primary g1-play-btn"
              @click.stop="g1PlayGame(game)"
              :disabled="!g1CanPlay(game.id)"
            >
              {{ g1CanPlay(game.id) ? 'PLAY' : '⏱ Earn time' }}
            </button>
          </div>
        </div>
        <div v-if="!g1FilteredGames.length" class="g1-empty g1-grid-empty">
          No games match the current filters
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

import SnakeGame   from '../games/SnakeGame1.vue';
import TetrisGame  from '../games/TetrisGame1.vue';
import MemoryGame  from '../games/MemoryGame1.vue';
import TicTacToe   from '../games/TicTacToe1.vue';
import PongGame    from '../games/PongGame1.vue';
import C1ModCalendar from '../../../components/C1ModCalendar.vue';

const API = '/api';

export default {
  name: 'Games1Container',

  components: {
    SnakeGame,
    TetrisGame,
    MemoryGame,
    TicTacToe,
    PongGame,
    C1ModCalendar,
  },

  computed: {
    ...mapState('user', ['auth']),

    g1PanelIsOpen() {
      return !!this.g1ActivePanel;
    },
    g1PanelAtContent() {
      return !!this.g1ActivePanel && this.g1ActivePanel !== 'nav' && this.g1ActivePanel !== 'menu';
    },
    g1ActivePanelLabel() {
      const labels = { filters: 'Filters', charts: 'Charts', calendar: 'Calendar', rankings: 'Rankings', viki: 'Viki' };
      return (this.g1ActivePanel && labels[this.g1ActivePanel]) ? labels[this.g1ActivePanel] : 'Panels';
    },

    // User identity
    g1UserName() {
      if (!this.auth || !this.auth.user) return 'User';
      return this.auth.user.first_name || 'User';
    },
    g1Initials() {
      if (!this.auth || !this.auth.user) return 'U';
      const u = this.auth.user;
      const f = (u.first_name || '').charAt(0).toUpperCase();
      const l = (u.last_name || '').charAt(0).toUpperCase();
      return f + l || 'U';
    },
    g1IsAdminRole() {
      const role = this.auth && this.auth.user && this.auth.user.role;
      return [1, 2, 3, 12].includes(Number(role));
    },

    // ── Nav shared computeds ──
    c1UserInitials() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "?";
      return ((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase();
    },
    c1UserFullName() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "User";
      return ((u.first_name || "") + " " + (u.last_name || "")).trim() || "User";
    },
    c1RoleLabel() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      const map = { 1:"Admin",2:"Team Leader",3:"Manager",4:"Senior Agent",5:"Agent",6:"Junior Agent",10:"Finance",12:"Super Admin" };
      return map[u && u.role] || "User";
    },
    c1TzUK() { return this.c1TzTime("Europe/London"); },
    c1TzIL() { return this.c1TzTime("Asia/Jerusalem"); },
    c1TzCB() { return this.c1TzTime("America/Cayman"); },

    // Filter computed
    g1ActiveFilterCount() {
      let count = 0;
      if (this.g1FilterType !== null) count++;
      if (this.g1FilterMode !== null) count++;
      if (this.g1FilterAccess !== 'all') count++;
      return count;
    },

    g1FilteredGames() {
      let games = this.g1Games.slice();
      if (this.g1FilterType) {
        games = games.filter(g => g.type === this.g1FilterType);
      }
      if (this.g1FilterAccess === 'earned') {
        games = games.filter(g => this.g1PermittedGames.includes(g.id));
      }
      return games;
    },

    g1GameTypes() {
      const types = [...new Set(this.g1Games.map(g => g.type))];
      return types;
    },

    // Leaderboard top 10 (aggregated across all games, best score per player)
    g1Top10() {
      const lb = this.g1GlobalLeaderboard;
      // If API returned a flat array (global top 10 by total score)
      if (Array.isArray(lb)) {
        return lb.slice(0, 10).map(function(e) {
          return { name: e.name || e.user_name || '', score: e.total_score || e.score || 0, game: '' };
        });
      }
      // If API returned object keyed by gameId: { gameId: [...entries] }
      const players = {};
      var self = this;
      Object.keys(lb).forEach(function(gameId) {
        const entries = lb[gameId];
        if (!Array.isArray(entries)) return;
        entries.forEach(function(e) {
          if (!players[e.user_id] || players[e.user_id].score < e.score) {
            players[e.user_id] = {
              name: e.name || '',
              score: e.score || 0,
              game: self.g1GameName(Number(gameId)),
            };
          }
        });
      });
      return Object.values(players)
        .sort(function(a, b) { return b.score - a.score; })
        .slice(0, 10);
    },

    g1LbMaxScore() {
      if (!this.g1Top10.length) return 1;
      return Math.max(...this.g1Top10.map(e => e.score), 1);
    },

    // Detail panel leaderboard based on active tab
    g1DetailLeaderboard() {
      if (!this.g1DetailGame) return [];
      const entries = (this.g1GlobalLeaderboard[this.g1DetailGame.id] || []).slice();
      // For weekly/shift, filter by date range
      if (this.g1DetailTab === 'Weekly') {
        const weekAgo = Date.now() - 7 * 24 * 3600 * 1000;
        return entries
          .filter(e => new Date(e.date).getTime() >= weekAgo)
          .sort((a, b) => b.score - a.score)
          .slice(0, 10);
      } else if (this.g1DetailTab === 'Shift') {
        const today = new Date();
        const todayStr = today.toISOString().slice(0, 10);
        return entries
          .filter(e => e.date && e.date.slice(0, 10) === todayStr)
          .sort((a, b) => b.score - a.score)
          .slice(0, 10);
      }
      return entries.sort((a, b) => b.score - a.score).slice(0, 10);
    },

    g1MyDetailPosition() {
      if (!this.g1DetailGame) return 0;
      const entries = (this.g1GlobalLeaderboard[this.g1DetailGame.id] || [])
        .slice()
        .sort((a, b) => b.score - a.score);
      const userId = this.auth && this.auth.user && this.auth.user.id;
      const idx = entries.findIndex(e => e.user_id === userId);
      return idx === -1 ? 0 : idx + 1;
    },

    g1MyDetailEntry() {
      if (!this.g1DetailGame) return null;
      const userId = this.auth && this.auth.user && this.auth.user.id;
      const entries = this.g1GlobalLeaderboard[this.g1DetailGame.id] || [];
      return entries.find(e => e.user_id === userId) || null;
    },

    g1MyScoreHistory() {
      if (!this.g1DetailGame) return [];
      return (this.g1MyScores[this.g1DetailGame.id] && this.g1MyScores[this.g1DetailGame.id].history) || [];
    },

    g1VikiUnread() {
      return this.g1VikiMessages.filter(m => !m.read).length;
    },

    g1OverallRank() {
      const top10 = this.g1Top10;
      const userId = this.auth && this.auth.user && this.auth.user.id;
      const idx = top10.findIndex(e => {
        // match by name since aggregated
        return this.auth && this.auth.user &&
          e.name === ((this.auth.user.first_name || '') + ' ' + (this.auth.user.last_name || '')).trim();
      });
      return idx === -1 ? '—' : idx + 1;
    },

    g1WeekDays() {
      const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      const now = new Date();
      const dow = now.getDay(); // 0=Sun
      // Monday of current week
      const monday = new Date(now);
      monday.setDate(now.getDate() - (dow === 0 ? 6 : dow - 1));
      return days.map((label, i) => {
        const d = new Date(monday);
        d.setDate(monday.getDate() + i);
        return {
          label,
          date: d.toISOString().slice(0, 10),
          dayNum: d.getDate(),
        };
      });
    },

    g1SprintCountdown() {
      const now = new Date();
      const dow = now.getDay();
      const daysUntilMonday = dow === 0 ? 1 : 8 - dow;
      const next = new Date(now);
      next.setDate(now.getDate() + daysUntilMonday);
      next.setHours(0, 0, 0, 0);
      const diffMs = next - now;
      const diffH = Math.floor(diffMs / 3600000);
      const diffD = Math.floor(diffH / 24);
      if (diffD > 1) return diffD + ' days';
      return diffH + ' hours';
    },

    g1GameComponent() {
      if (!this.g1ActiveGame) return null;
      const routeMap = {
        TIC:     'TicTacToe',
        SNAKE:   'SnakeGame',
        TETRIS:  'TetrisGame',
        PONG:    'PongGame',
        Memory:  'MemoryGame',
      };
      return routeMap[this.g1ActiveGame.route] || null;
    },

    // Rankings panel: per-game leaderboard with real system users
    g1RankingsGames() {
      var self = this;
      return this.g1Games.map(function(game) {
        var entries = [];
        var lb = self.g1GlobalLeaderboard;
        if (lb && lb[game.id] && Array.isArray(lb[game.id])) {
          entries = lb[game.id].slice().sort(function(a, b) { return b.score - a.score; }).slice(0, 5);
        }
        return { game: game, entries: entries };
      });
    },

    // Team Battle: aggregate all leaderboard scores by team_id
    g1TeamScores() {
      const team1 = { id: 1, name: 'Team 1', emoji: '⚡', members: {}, total: 0 };
      const team2 = { id: 2, name: 'Team 2', emoji: '🔥', members: {}, total: 0 };
      const lb = this.g1GlobalLeaderboard;
      // Also use agentList which may have team_id
      const agentMap = {};
      this.g1AgentList.forEach(function(a) {
        if (a.id) agentMap[a.id] = a;
      });
      Object.keys(lb).forEach(function(gameId) {
        const entries = lb[gameId];
        if (!Array.isArray(entries)) return;
        entries.forEach(function(e) {
          const agent = agentMap[e.user_id] || {};
          const tid = e.team_id || agent.team_id || null;
          if (!tid) return;
          const bucket = tid === 1 ? team1 : tid === 2 ? team2 : null;
          if (!bucket) return;
          const uid = e.user_id;
          if (!bucket.members[uid]) {
            bucket.members[uid] = { name: e.name || agent.name || 'Agent', score: 0 };
          }
          bucket.members[uid].score += e.score || 0;
          bucket.total += e.score || 0;
        });
      });
      // Sort members by score desc
      const sortMembers = (bucket) => {
        return Object.values(bucket.members).sort((a, b) => b.score - a.score);
      };
      return {
        team1: { ...team1, memberList: sortMembers(team1) },
        team2: { ...team2, memberList: sortMembers(team2) },
      };
    },

    g1BattleBarPct() {
      const t1 = this.g1TeamScores.team1.total;
      const t2 = this.g1TeamScores.team2.total;
      const total = t1 + t2;
      if (!total) return { t1: 50, t2: 50 };
      return { t1: Math.round((t1 / total) * 100), t2: Math.round((t2 / total) * 100) };
    },

    g1BattleWinner() {
      const t1 = this.g1TeamScores.team1.total;
      const t2 = this.g1TeamScores.team2.total;
      if (t1 > t2) return 1;
      if (t2 > t1) return 2;
      return 0;
    },
  },

  data() {
    return {
      // Panel state
      c1TopTab: null,
      c1NavMode: 'panels',
      g1ActivePanel: null,
      g1PanelActiveContent: null,
      g1AdminPanelOpen: false,

      // Loading
      g1Loading: false,

      // Toast
      g1Toast: null,
      g1ToastTimer: null,

      // Filters
      g1FilterType: null,
      g1FilterMode: null,
      g1FilterAccess: 'all',

      // Credits
      g1Credits: 0,
      g1CreditsBreakdown: { deposits: 0, calls: 0, attendance: 0 },

      // Game definitions
      g1Games: [
        { id: 1, name: 'Tic Tac Toe', emoji: '⭕', route: 'TIC', color: '#6366f1', type: 'Classic' },
        { id: 2, name: 'Snake', emoji: '🐍', route: 'SNAKE', color: '#22c55e', type: 'Reflex' },
        { id: 3, name: 'Tetris', emoji: '🧱', route: 'TETRIS', color: '#f59e0b', type: 'Skill' },
        { id: 4, name: 'Pac-Man', emoji: '👾', route: 'PACMAN', color: '#eab308', type: 'Reflex' },
        { id: 5, name: 'Brick Breaker', emoji: '🎯', route: 'BREAKER', color: '#ef4444', type: 'Skill' },
        { id: 6, name: 'Pong', emoji: '🏓', route: 'PONG', color: '#3b82f6', type: 'Reflex' },
        { id: 7, name: 'Simon Says', emoji: '🎵', route: 'SIMONGAME', color: '#ec4899', type: 'Memory' },
        { id: 8, name: 'Memory', emoji: '🧠', route: 'Memory', color: '#8b5cf6', type: 'Memory' },
        { id: 9, name: 'Minesweeper', emoji: '💣', route: 'MINESWEEPER', color: '#6b7280', type: 'Puzzle' },
        { id: 10, name: 'Snakes & Ladders', emoji: '🎲', route: 'Snakes', color: '#14b8a6', type: 'Classic' },
      ],

      // Permissions
      g1PermittedGames: [],
      g1EnabledGames: [],

      // Scores data
      // g1MyScores: { [gameId]: { best: N, rank: N, history: [...] } }
      g1MyScores: {},
      // g1GlobalLeaderboard: { [gameId]: [ { user_id, name, score, date } ] }
      g1GlobalLeaderboard: {},
      // g1PlayCounts: { [gameId]: N }
      g1PlayCounts: {},
      // g1WeeklySprint: [ { game_id, leader_name, score } ]
      g1WeeklySprint: [],

      // Calendar
      g1CalendarPlays: [], // [ { date, game_id, player_name, score } ]
      g1CalSelectedDay: null,

      // Viki
      g1VikiMessages: [],

      // Game detail drawer
      g1DetailGame: null,
      g1DetailTab: 'All-time',

      // Challenge
      g1ChallengeTarget: '',
      g1AgentList: [],

      // Active game overlay
      g1ActiveGame: null,
      g1CreditCountdown: 0,
      g1LiveScore: 0,
      g1CreditTimer: null,

      // Admin grant
      g1GrantTarget: '',
      g1GrantMinutes: null,
      g1GrantReason: '',

      // Tournaments
      g1Tournaments: [],

      // Achievements
      g1Achievements: [],

      // Rankings panel
      g1RankOpenGame: null,

      // Team leaderboard mode
      g1LeaderboardMode: 'individual', // 'individual' | 'team'
    };
  },

  created() {
    if (sessionStorage.getItem('c1keepNav')) {
      sessionStorage.removeItem('c1keepNav');
      this.g1ActivePanel = 'nav';
      this.c1NavMode = 'panels';
    }
    sessionStorage.removeItem('c1openPanel');
  },

  async mounted() {
    await this.g1LoadAll();
  },

  beforeDestroy() {
    if (this.g1CreditTimer) clearInterval(this.g1CreditTimer);
    if (this.g1ToastTimer) clearTimeout(this.g1ToastTimer);
  },

  watch: {
    'g1ActivePanel': function(val) {
      if (val && val !== 'nav' && val !== 'menu') {
        this.g1PanelActiveContent = val;
      }
    }
  },

  methods: {

    // ── Nav shared methods ────────────────────────────────────────────────
    c1TzTime(tz) {
      try {
        return new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz });
      } catch(e) { return "--:--"; }
    },
    c1Logout() {
      this.$store.dispatch('user/logOut');
    },

    // ── AUTH ──────────────────────────────────────────────────────────────
    g1AuthHeaders() {
      return { Authorization: 'Bearer ' + localStorage.getItem('user-token') };
    },

    // ── DATA LOADING ──────────────────────────────────────────────────────
    async g1LoadAll() {
      this.g1Loading = true;
      try {
        await Promise.all([
          this.g1LoadPermissions(),
          this.g1LoadScores(),
          this.g1LoadLeaderboard(),
          this.g1LoadViki(),
          this.g1LoadAgents(),
          this.g1LoadTournaments(),
          this.g1LoadAchievements(),
          this.g1LoadCalendar(),
        ]);
      } catch (err) {
        this.g1ShowToast('Failed to load game data', '#ef4444');
        console.error('[Games1] load error:', err);
      } finally {
        this.g1Loading = false;
      }
    },

    async g1LoadPermissions() {
      try {
        const res = await axios.get(API + '/games/perm/check', { headers: this.g1AuthHeaders() });
        // API returns plain array of permitted game IDs
        const data = res.data;
        const permitted = Array.isArray(data) ? data : (data && data.permitted) || [];
        this.g1PermittedGames = permitted;
        this.g1EnabledGames = (data && data.enabled) || this.g1Games.map(function(g) { return g.id; });
      } catch (e) {
        // Default: all games permitted for admins
        if (this.g1IsAdminRole) {
          this.g1PermittedGames = this.g1Games.map(function(g) { return g.id; });
          this.g1EnabledGames = this.g1Games.map(function(g) { return g.id; });
        }
      }
    },

    async g1LoadScores() {
      try {
        const res = await axios.get(`${API}/games/my-scores`, { headers: this.g1AuthHeaders() });
        // API returns: { success, data: { per_game: [{game_id, best_score, rank}], overall_rank, minutes_balance } }
        const payload = (res.data && res.data.data) || res.data || {};
        this.g1Credits = payload.minutes_balance || 0;
        // Convert per_game array to { [gameId]: { best, rank } }
        const perGame = Array.isArray(payload.per_game) ? payload.per_game : [];
        const scoresMap = {};
        perGame.forEach(function(entry) {
          scoresMap[entry.game_id] = { best: entry.best_score, rank: entry.rank };
        });
        this.g1MyScores = scoresMap;
        this.g1PlayCounts = {};
        console.log('[Games1] scores loaded:', scoresMap);
      } catch (e) {
        console.warn('[Games1] my-scores error:', e);
        // Admins always get credits so they can play
        if (this.g1IsAdminRole) this.g1Credits = 999;
      }
    },

    async g1LoadLeaderboard() {
      try {
        const res = await axios.get(`${API}/games/leaderboard`, { headers: this.g1AuthHeaders() });
        // API returns: { success, data: { [gameId]: [{rank, user_id, name, score}] } }
        const payload = (res.data && res.data.data) || res.data || {};
        // Only assign as leaderboard if it's a plain object (not a game-list array)
        if (!Array.isArray(payload) && typeof payload === 'object') {
          this.g1GlobalLeaderboard = payload;
          this.g1WeeklySprint = payload.weekly_sprint || [];
          this.g1CalendarPlays = payload.calendar || [];
        }
        console.log('[Games1] leaderboard loaded:', payload);
      } catch (e) {
        console.warn('[Games1] leaderboard error:', e);
      }
    },

    async g1LoadViki() {
      // No viki/messages endpoint yet — use local Viki messages from game events
      this.g1VikiMessages = [];
    },

    async g1LoadAgents() {
      try {
        // Use Vuex store if available, otherwise load from users API
        const list = this.$store && this.$store.state.clients && this.$store.state.clients.salesPersonList;
        if (list && list.length) {
          this.g1AgentList = list.map(function(a) {
            return { id: a.id, name: ((a.first_name || '') + ' ' + (a.last_name || '')).trim(), team_id: a.team_id || null };
          });
        } else {
          const res = await axios.get(API + '/admin/user', { headers: this.g1AuthHeaders() });
          const users = (res.data && res.data.data) || res.data || [];
          this.g1AgentList = (Array.isArray(users) ? users : []).map(function(a) {
            return { id: a.id, name: ((a.first_name || '') + ' ' + (a.last_name || '')).trim(), team_id: a.team_id || null };
          });
        }
      } catch (e) {
        this.g1AgentList = [];
      }
    },

    async g1LoadTournaments() {
      // Use weekly sprint data from leaderboard instead of a separate endpoint
      try {
        const sprints = this.g1WeeklySprint || [];
        this.g1Tournaments = Array.isArray(sprints) ? sprints : [];
      } catch (e) {
        this.g1Tournaments = [];
      }
    },

    async g1LoadAchievements() {
      try {
        const res = await axios.get(`${API}/games/achievements`, { headers: this.g1AuthHeaders() });
        this.g1Achievements = (res.data && res.data.data) || res.data || [];
      } catch (e) {
        this.g1Achievements = [];
      }
    },

    async g1LoadCalendar() {
      // Calendar data comes from user_scores table — use my-scores which includes play dates
      // No dedicated calendar endpoint yet; calendar will show dots from g1MyScores history
      this.g1CalendarPlays = [];
    },

    // ── PANEL TOGGLE ──────────────────────────────────────────────────────
    g1PanelBtnClick() {
      this.g1ActivePanel = 'nav';
    },
    g1SelectPanel(panel) {
      if (panel === 'nav') {
        this.g1ActivePanel = 'nav';
      } else {
        this.g1PanelActiveContent = panel;
        this.g1ActivePanel = panel;
      }
    },
    g1TogglePanel(name) {
      this.g1ActivePanel = this.g1ActivePanel === name ? null : name;
    },

    // ── FILTER RESET ──────────────────────────────────────────────────────
    g1ResetFilters() {
      this.g1FilterType = null;
      this.g1FilterMode = null;
      this.g1FilterAccess = 'all';
    },

    // ── GAME CARD HELPERS ─────────────────────────────────────────────────
    g1CardTop3(gameId) {
      const lb = this.g1GlobalLeaderboard[gameId];
      if (!lb || !Array.isArray(lb) || !lb.length) return [];
      return lb.slice().sort((a, b) => b.score - a.score).slice(0, 3).map(function(e, i) {
        const medals = ['🥇','🥈','🥉'];
        const short = (e.name || '').split(' ').map(function(p) { return p.charAt(0).toUpperCase() + p.slice(1); }).join(' ');
        return { medal: medals[i], name: short, score: e.score };
      });
    },

    g1MyBest(gameId) {
      const s = this.g1MyScores[gameId];
      if (!s) return null;
      return s.best !== undefined ? s.best : null;
    },

    g1CompanyRecord(gameId) {
      const lb = this.g1GlobalLeaderboard[gameId];
      if (!lb || !Array.isArray(lb) || !lb.length) return null;
      const sorted = lb.slice().sort((a, b) => b.score - a.score);
      return sorted[0] ? sorted[0].score : null;
    },

    g1MyRank(gameId) {
      const s = this.g1MyScores[gameId];
      if (!s || s.rank === undefined) return null;
      return s.rank;
    },

    g1PlayerCount(gameId) {
      const lb = this.g1GlobalLeaderboard[gameId];
      if (!lb || !Array.isArray(lb)) return 0;
      const unique = new Set(lb.map(e => e.user_id));
      return unique.size;
    },

    g1IsNearRecord(gameId) {
      const best = this.g1MyBest(gameId);
      const record = this.g1CompanyRecord(gameId);
      if (best === null || record === null || record === 0) return false;
      return best >= record * 0.85;
    },

    g1CanPlay(gameId) {
      if (this.g1IsAdminRole) return true;
      if (!this.g1PermittedGames.includes(gameId)) return false;
      return this.g1Credits > 0;
    },

    g1RankClass(gameId) {
      const rank = this.g1MyRank(gameId);
      if (rank === 1) return 'rank-gold';
      if (rank === 2) return 'rank-silver';
      if (rank === 3) return 'rank-bronze';
      return 'rank-default';
    },

    g1GameName(gameId) {
      const game = this.g1Games.find(g => g.id === gameId);
      return game ? game.name : 'Unknown';
    },

    g1GameEmoji(gameId) {
      const game = this.g1Games.find(g => g.id === gameId);
      return game ? game.emoji : '🎮';
    },

    // ── GAME DETAIL DRAWER ────────────────────────────────────────────────
    g1OpenGameDetail(game) {
      this.g1DetailGame = game;
      this.g1DetailTab = 'All-time';
      this.g1ChallengeTarget = '';
    },

    g1IsMe(userId) {
      return this.auth && this.auth.user && this.auth.user.id === userId;
    },

    async g1SendChallenge() {
      if (!this.g1ChallengeTarget || !this.g1DetailGame) return;
      try {
        await axios.post(`${API}/users/scheduled_calls/approve_sc`, {
          to_user_id: this.g1ChallengeTarget,
          text: `I challenge you to beat my score in ${this.g1DetailGame.name}! Are you ready? 🎮`,
          module: 'games',
        }, { headers: this.g1AuthHeaders() });
        this.g1ShowToast('Challenge sent!', '#22c55e');
        this.g1ChallengeTarget = '';
      } catch (e) {
        this.g1ShowToast('Failed to send challenge', '#ef4444');
      }
    },

    // ── PLAY GAME ─────────────────────────────────────────────────────────
    g1PlayGame(game) {
      if (!this.g1CanPlay(game.id)) return;
      this.g1ActiveGame = game;
      this.g1LiveScore = 0;
      // Admins always get at least 999 min regardless of credits balance
      this.g1CreditCountdown = this.g1IsAdminRole ? Math.max(this.g1Credits, 999) : this.g1Credits;
      this.g1DetailGame = null;
      this.g1ActivePanel = null;
      // Start countdown
      this.g1CreditTimer = setInterval(() => {
        if (this.g1CreditCountdown <= 0) {
          clearInterval(this.g1CreditTimer);
          this.g1CreditTimer = null;
          this.g1HandleGameOver(this.g1LiveScore);
        } else {
          this.g1CreditCountdown--;
        }
      }, 60000);
    },

    g1CloseGame() {
      if (this.g1CreditTimer) {
        clearInterval(this.g1CreditTimer);
        this.g1CreditTimer = null;
      }
      this.g1ActiveGame = null;
      this.g1LiveScore = 0;
      this.g1CreditCountdown = 0;
    },

    g1HandleScoreUpdate(score) {
      this.g1LiveScore = score;
    },

    async g1HandleGameOver(score) {
      if (!this.g1ActiveGame) return;
      if (this.g1CreditTimer) {
        clearInterval(this.g1CreditTimer);
        this.g1CreditTimer = null;
      }
      const gameId = this.g1ActiveGame.id;
      try {
        await axios.post(`${API}/games/score`, {
          game_id: gameId,
          score: score,
          mode: 'full',
          during_call: false,
        }, { headers: this.g1AuthHeaders() });
        this.g1ShowToast('Score saved: ' + score.toLocaleString(), '#6366f1');
      } catch (e) {
        this.g1ShowToast('Score save failed', '#ef4444');
      }
      await this.g1LoadScores();
      await this.g1LoadLeaderboard();
      this.g1CloseGame();
    },

    // ── CHART HELPERS ─────────────────────────────────────────────────────
    g1LbBarPct(score) {
      const max = this.g1LbMaxScore;
      if (!max) return 0;
      return Math.round((score / max) * 100);
    },

    g1PlayFreq(gameId) {
      return this.g1PlayCounts[gameId] || 0;
    },

    g1FreqBarPct(gameId) {
      const counts = Object.values(this.g1PlayCounts);
      const max = Math.max(...counts, 1);
      return Math.round(((this.g1PlayCounts[gameId] || 0) / max) * 100);
    },

    g1SprintLeader(gameId) {
      const entry = this.g1WeeklySprint.find(e => e.game_id === gameId);
      return entry ? entry.leader_name : '—';
    },

    g1SprintScore(gameId) {
      const entry = this.g1WeeklySprint.find(e => e.game_id === gameId);
      return entry ? (entry.score || 0).toLocaleString() : '—';
    },

    // ── CALENDAR HELPERS ──────────────────────────────────────────────────
    g1IsToday(dateStr) {
      return dateStr === new Date().toISOString().slice(0, 10);
    },

    g1DayHasPlay(dateStr) {
      return this.g1CalendarPlays.some(p => p.date && p.date.slice(0, 10) === dateStr);
    },

    g1DayEntries(dateStr) {
      return this.g1CalendarPlays.filter(p => p.date && p.date.slice(0, 10) === dateStr);
    },

    g1CalDayClick(day) {
      if (this.g1CalSelectedDay && this.g1CalSelectedDay.date === day.date) {
        this.g1CalSelectedDay = null;
      } else {
        this.g1CalSelectedDay = day;
      }
    },

    // ── ADMIN ─────────────────────────────────────────────────────────────
    async g1ToggleGameEnabled(gameId) {
      const isEnabled = this.g1EnabledGames.includes(gameId);
      if (isEnabled) {
        this.g1EnabledGames = this.g1EnabledGames.filter(id => id !== gameId);
      } else {
        this.g1EnabledGames.push(gameId);
      }
      try {
        await axios.put(`${API}/users/games/perm/user/0`, {
          game_id: gameId,
          enabled: !isEnabled,
        }, { headers: this.g1AuthHeaders() });
      } catch (e) {
        // Revert on error
        if (isEnabled) {
          this.g1EnabledGames.push(gameId);
        } else {
          this.g1EnabledGames = this.g1EnabledGames.filter(id => id !== gameId);
        }
        this.g1ShowToast('Toggle failed', '#ef4444');
      }
    },

    async g1SubmitGrant() {
      if (!this.g1GrantTarget || !this.g1GrantMinutes) return;
      try {
        await axios.put(`${API}/users/games/perm/user/${this.g1GrantTarget}`, {
          minutes: this.g1GrantMinutes,
          reason: this.g1GrantReason,
        }, { headers: this.g1AuthHeaders() });
        this.g1ShowToast(`Granted ${this.g1GrantMinutes} min`, '#22c55e');
        this.g1GrantTarget = '';
        this.g1GrantMinutes = null;
        this.g1GrantReason = '';
      } catch (e) {
        this.g1ShowToast('Grant failed', '#ef4444');
      }
    },

    // ── UTILITY ───────────────────────────────────────────────────────────
    g1NameInitials(name) {
      if (!name) return '?';
      const parts = name.trim().split(' ');
      const f = parts[0] ? parts[0].charAt(0).toUpperCase() : '';
      const l = parts[1] ? parts[1].charAt(0).toUpperCase() : '';
      return f + l || '?';
    },

    g1FormatDate(dateStr) {
      if (!dateStr) return '—';
      try {
        const d = new Date(dateStr);
        return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
      } catch {
        return dateStr;
      }
    },

    g1FormatTime(dateStr) {
      if (!dateStr) return '';
      try {
        const d = new Date(dateStr);
        return d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
      } catch {
        return '';
      }
    },

    async g1QuickChallenge(entry, game) {
      if (!entry || !game) return;
      try {
        await axios.post(API + '/users/scheduled_calls/approve_sc', {
          to_user_id: entry.user_id,
          text: 'I challenge you to beat my score in ' + game.name + '! Are you ready? 🎮',
          module: 'games',
        }, { headers: this.g1AuthHeaders() });
        this.g1ShowToast('Challenge sent to ' + entry.name + '!', '#22c55e');
      } catch (e) {
        this.g1ShowToast('Failed to send challenge', '#ef4444');
      }
    },

    g1ShowToast(msg, color = '#6366f1') {
      if (this.g1ToastTimer) clearTimeout(this.g1ToastTimer);
      this.g1Toast = { msg, color };
      this.g1ToastTimer = setTimeout(() => { this.g1Toast = null; }, 3000);
    },

    // ── TEAM HELPERS ──────────────────────────────────────────────────────
    g1EntryTeamId(entry) {
      if (!entry) return null;
      if (entry.team_id) return entry.team_id;
      const agent = this.g1AgentList.find(a => a.id === entry.user_id);
      return agent ? agent.team_id : null;
    },

    g1TeamDotColor(entry) {
      const tid = this.g1EntryTeamId(entry);
      if (tid === 1) return '#0e7490';
      if (tid === 2) return '#7c3aed';
      return 'transparent';
    },

    g1AnimateCounters() {
      // Simple mount animation hook — Vue transitions handle the visual
    },
  },
};
</script>

<style scoped>

/* ── BASE ──────────────────────────────────────────────────────────────── */
.c1-main {
  min-height: 100vh;
  background: #fff;
  color: var(--c1-t1);
  font-family: inherit;
}

/* ── TOAST ─────────────────────────────────────────────────────────────── */
.g1-toast {
  position: fixed;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999;
  padding: 10px 22px;
  border-radius: 24px;
  color: #fff;
  font-size: .85rem;
  font-weight: 600;
  box-shadow: 0 4px 20px rgba(0,0,0,.25);
  pointer-events: none;
  white-space: nowrap;
  height: auto;
  line-height: 1.4;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.g1-toast-fade-enter-active,
.g1-toast-fade-leave-active { transition: opacity .25s, transform .25s; }
.g1-toast-fade-enter,
.g1-toast-fade-leave-to { opacity: 0; transform: translateX(-50%) translateY(10px); }

/* ── TOP BAR — use global c1-design.css .c1-tib, only extend here ──────── */
.c1-tib-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.c1-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--c1-dp);
  color: #fff;
  font-size: .75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.c1-tib-title {
  font-weight: 600;
  font-size: .9rem;
  color: var(--c1-t1);
  letter-spacing: .01em;
}

.c1-hp {
  flex: 1;
}

.g1-credits-chip {
  background: rgba(99, 102, 241, .15);
  border: 1px solid rgba(99, 102, 241, .3);
  border-radius: 20px;
  padding: 4px 12px;
  font-size: .8rem;
  color: var(--c1-dp);
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

/* c1-tib-btn — global class handles layout, only extend colors here */
.c1-tib-badge {
  background: var(--c1-dp);
  color: #fff;
  font-size: .65rem;
  font-weight: 700;
  border-radius: 10px;
  padding: 1px 5px;
  line-height: 1.4;
  position: absolute;
  top: 2px;
  right: 2px;
}

.c1-tib-user-name {
  font-size: .75rem;
  color: var(--c1-t2);
  padding: 0 6px;
  flex-shrink: 0;
  white-space: nowrap;
}

/* .c1-panel-backdrop — defined globally in c1-design.css */

/* ── PANELS — global .c1-panel handles base, extend here ───────────────── */

/* detail + admin panels use default c1-panel right-side slide */


/* Panel header / body — use global c1-design.css where possible */
.c1-panel-hdr-bar {
  height: 44px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 14px;
  border-bottom: 1px solid var(--c1-brd-l);
  flex-shrink: 0;
  background: var(--c1-card);
}
.c1-panel-hdr-bar > svg {
  width: 14px;
  height: 14px;
  stroke: var(--c1-dp);
  fill: none;
  stroke-width: 2;
  flex-shrink: 0;
}
.c1-panel-hdr-ttl {
  font-weight: 700;
  font-size: 12px;
  color: var(--c1-t1);
  flex: 1;
  letter-spacing: .01em;
}
.c1-panel-hdr-count {
  font-size: 10px;
  color: var(--c1-dp);
  background: rgba(124,92,252,.1);
  border-radius: 10px;
  padding: 2px 8px;
  font-weight: 600;
}
.c1-collapse-btn {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  cursor: pointer;
  color: var(--c1-t3);
  transition: background .15s, color .15s;
  flex-shrink: 0;
}
.c1-collapse-btn:hover { background: var(--c1-act); color: var(--c1-t1); }
.c1-collapse-btn svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; }

.c1-sl-body {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0 24px;
}
.c1-sl-body::-webkit-scrollbar { width: 3px; }
.c1-sl-body::-webkit-scrollbar-track { background: transparent; }
.c1-sl-body::-webkit-scrollbar-thumb { background: var(--c1-brd); border-radius: 2px; }

/* ── SECTION LABELS ──────────────────────────────────────────────────── */
.c1-fs-section-lbl {
  padding: 10px 14px 5px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: .08em;
  color: var(--c1-t3);
  text-transform: uppercase;
}

/* ── FILTER CHIPS ──────────────────────────────────────────────────────── */
.g1-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 4px 14px 8px;
}
.g1-chip {
  padding: 5px 12px;
  border-radius: 20px;
  font-size: .78rem;
  font-weight: 500;
  background: #f8f8fb;
  border: 1px solid var(--c1-brd);
  color: var(--c1-muted);
  cursor: pointer;
  transition: all .15s;
  user-select: none;
}
.g1-chip:hover {
  border-color: var(--c1-dp);
  color: var(--c1-dp);
}
.g1-chip.on {
  background: var(--c1-dp);
  border-color: var(--c1-dp);
  color: #fff;
}

/* ── RANK OVERVIEW ─────────────────────────────────────────────────────── */
.g1-rank-overview {
  margin: 4px 14px 8px;
  background: rgba(99,102,241,.08);
  border: 1px solid rgba(99,102,241,.2);
  border-radius: 10px;
  padding: 12px 16px;
}
.g1-rank-overview-inner {
  display: flex;
  align-items: baseline;
  gap: 10px;
}
.g1-rank-num {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--c1-dp);
}
.g1-rank-sub {
  font-size: .75rem;
  color: var(--c1-muted);
}

/* ── RESET BAR ─────────────────────────────────────────────────────────── */
.c1-reset-bar {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 8px 14px 4px;
  padding: 8px 12px;
  border-radius: 8px;
  background: rgba(239,68,68,.1);
  border: 1px solid rgba(239,68,68,.2);
  color: #ef4444;
  font-size: .8rem;
  cursor: pointer;
  transition: background .15s;
}
.c1-reset-bar:hover { background: rgba(239,68,68,.16); }
.c1-reset-bar svg {
  width: 13px;
  height: 13px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2;
}
.c1-reset-bar-count {
  margin-left: auto;
  background: #ef4444;
  color: #fff;
  font-size: .65rem;
  font-weight: 700;
  border-radius: 10px;
  padding: 1px 6px;
}

/* ── CHARTS PANEL ──────────────────────────────────────────────────────── */
.g1-chart-ttl {
  padding: 10px 14px 6px;
  font-size: .78rem;
  font-weight: 700;
  color: var(--c1-t1);
}
.g1-chart-block {
  margin: 0 14px 4px;
  background: #f9f9fb;
  border: 1px solid var(--c1-brd-l);
  border-radius: 8px;
  padding: 10px 12px;
}

/* leaderboard rows */
.g1-lb-row {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 5px 0;
  border-bottom: 1px solid var(--c1-brd);
}
.g1-lb-row:last-child { border-bottom: none; }
.g1-lb-rank {
  font-size: .75rem;
  font-weight: 700;
  width: 24px;
  text-align: center;
  flex-shrink: 0;
}
.g1-lb-av {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--c1-dp);
  color: #fff;
  font-size: .65rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.g1-lb-info { flex: 1; min-width: 0; }
.g1-lb-name {
  font-size: .78rem;
  font-weight: 500;
  color: var(--c1-t1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.g1-lb-game-tag {
  font-size: .68rem;
  color: var(--c1-muted);
}
.g1-lb-bar-wrap {
  width: 70px;
  height: 6px;
  background: var(--c1-brd);
  border-radius: 3px;
  overflow: hidden;
  flex-shrink: 0;
}
.g1-lb-bar-fill {
  height: 100%;
  border-radius: 3px;
  transition: width .4s;
}
.bar-gold    { background: #f59e0b; }
.bar-silver  { background: #94a3b8; }
.bar-bronze  { background: #cd7f32; }
.bar-default { background: var(--c1-dp); }
.g1-lb-score {
  font-size: .75rem;
  font-weight: 600;
  color: var(--c1-t1);
  width: 44px;
  text-align: right;
  flex-shrink: 0;
}

/* frequency rows */
.g1-freq-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
  border-bottom: 1px solid var(--c1-brd);
}
.g1-freq-row:last-child { border-bottom: none; }
.g1-freq-emoji { font-size: 1.1rem; flex-shrink: 0; }
.g1-freq-name {
  font-size: .75rem;
  color: var(--c1-t1);
  width: 80px;
  flex-shrink: 0;
}
.g1-freq-count {
  font-size: .72rem;
  color: var(--c1-muted);
  width: 28px;
  text-align: right;
  flex-shrink: 0;
}

/* balance */
.g1-balance-big {
  font-size: 2.4rem;
  font-weight: 700;
  color: var(--c1-dp);
  line-height: 1;
  margin-bottom: 10px;
}
.g1-balance-unit {
  font-size: 1rem;
  font-weight: 400;
  color: var(--c1-muted);
}
.g1-bb-row {
  display: flex;
  justify-content: space-between;
  font-size: .78rem;
  color: var(--c1-muted);
  padding: 3px 0;
  border-top: 1px solid var(--c1-brd);
}
.g1-bb-row span:last-child {
  color: var(--c1-t1);
  font-weight: 500;
}

/* sprint */
.g1-sprint-countdown {
  font-size: .8rem;
  color: var(--c1-muted);
  margin-bottom: 8px;
}
.g1-sprint-countdown strong { color: var(--c1-t1); }
.g1-sprint-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
  border-bottom: 1px solid var(--c1-brd);
  font-size: .78rem;
}
.g1-sprint-row:last-child { border-bottom: none; }
.g1-sprint-emoji { font-size: 1rem; flex-shrink: 0; }
.g1-sprint-name { flex: 1; color: var(--c1-t1); }
.g1-sprint-leader { color: var(--c1-muted); font-size: .72rem; }
.g1-sprint-score { color: var(--c1-dp); font-weight: 600; }

/* ── CALENDAR PANEL ────────────────────────────────────────────────────── */
.g1-cal-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
  padding: 10px 14px;
}
.g1-cal-day {
  border: 1px solid var(--c1-brd);
  border-radius: 7px;
  padding: 8px 4px 6px;
  text-align: center;
  cursor: pointer;
  transition: border-color .15s, background .15s;
  background: #f8f8fb;
}
.g1-cal-day:hover {
  border-color: var(--c1-dp);
}
.g1-cal-today {
  border-color: var(--c1-dp) !important;
  background: rgba(99,102,241,.08);
}
.g1-cal-day-label {
  font-size: .6rem;
  font-weight: 700;
  color: var(--c1-muted);
  text-transform: uppercase;
  letter-spacing: .05em;
}
.g1-cal-day-num {
  font-size: .9rem;
  font-weight: 600;
  color: var(--c1-t1);
  margin: 2px 0;
}
.g1-cal-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--c1-dp);
  margin: 0 auto;
}
.g1-cal-detail {
  margin: 6px 14px 8px;
  background: #f8f8fb;
  border: 1px solid var(--c1-brd);
  border-radius: 8px;
  padding: 10px 12px;
}
.g1-cal-detail-hdr {
  font-size: .8rem;
  font-weight: 700;
  color: var(--c1-t1);
  margin-bottom: 8px;
}
.g1-cal-entry {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
  border-top: 1px solid var(--c1-brd);
  font-size: .78rem;
}
.g1-cal-entry-emoji { font-size: .95rem; flex-shrink: 0; }
.g1-cal-entry-name { flex: 1; color: var(--c1-t1); }
.g1-cal-entry-score {
  color: var(--c1-dp);
  font-weight: 600;
}

/* ── VIKI PANEL ────────────────────────────────────────────────────────── */
.g1-viki-msg {
  display: flex;
  gap: 10px;
  padding: 10px 14px;
  border-bottom: 1px solid var(--c1-brd);
  transition: background .15s;
}
.g1-viki-msg:hover { background: #f8f8fb; }
.g1-viki-unread { background: rgba(99,102,241,.05); }
.g1-viki-av {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--c1-dp);
  color: #fff;
  font-size: .65rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.g1-viki-body { flex: 1; min-width: 0; }
.g1-viki-from {
  font-size: .78rem;
  font-weight: 600;
  color: var(--c1-t1);
  margin-bottom: 2px;
}
.g1-viki-text {
  font-size: .78rem;
  color: var(--c1-muted);
  word-break: break-word;
}
.g1-viki-time {
  font-size: .68rem;
  color: var(--c1-muted);
  margin-top: 4px;
}

/* ── GAME DETAIL DRAWER ────────────────────────────────────────────────── */
.g1-tab-row {
  display: flex;
  gap: 4px;
  padding: 10px 14px 6px;
}
.g1-tab {
  padding: 5px 12px;
  border-radius: 6px;
  font-size: .78rem;
  font-weight: 500;
  border: 1px solid var(--c1-brd);
  color: var(--c1-muted);
  cursor: pointer;
  transition: all .15s;
}
.g1-tab.on {
  background: var(--c1-dp);
  border-color: var(--c1-dp);
  color: #fff;
}
.g1-detail-emoji { font-size: 1.3rem; }

.g1-lb-list {
  padding: 0 14px;
}
.g1-lb-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 0;
  border-bottom: 1px solid var(--c1-brd);
}
.g1-lb-item:last-child { border-bottom: none; }
.g1-lb-me {
  background: rgba(99,102,241,.06);
  border-radius: 6px;
  padding-left: 6px;
}
.g1-lb-medal {
  font-size: .85rem;
  width: 28px;
  flex-shrink: 0;
  text-align: center;
}
.g1-lb-date {
  font-size: .68rem;
  color: var(--c1-muted);
}
.g1-lb-sep {
  text-align: center;
  color: var(--c1-muted);
  font-size: .75rem;
  padding: 4px 0;
  letter-spacing: .2em;
}

.g1-history-list {
  padding: 4px 14px;
}
.g1-history-row {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  font-size: .78rem;
  border-bottom: 1px solid var(--c1-brd);
}
.g1-history-row:last-child { border-bottom: none; }
.g1-history-date { color: var(--c1-muted); }
.g1-history-score {
  color: var(--c1-dp);
  font-weight: 600;
}

.g1-challenge-section { padding: 10px 14px; }
.g1-challenge-row {
  display: flex;
  gap: 8px;
  margin-top: 6px;
}
.g1-challenge-select {
  flex: 1;
  background: #f8f8fb;
  border: 1px solid var(--c1-brd);
  color: var(--c1-t1);
  border-radius: 6px;
  padding: 6px 8px;
  font-size: .8rem;
  min-width: 0;
}

/* ── ADMIN PANEL ───────────────────────────────────────────────────────── */
.g1-admin-game-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-bottom: 1px solid var(--c1-brd);
}
.g1-admin-emoji { font-size: 1.2rem; flex-shrink: 0; }
.g1-admin-name {
  flex: 1;
  font-size: .82rem;
  color: var(--c1-t1);
}

/* toggle switch */
.g1-toggle { position: relative; display: inline-block; width: 36px; height: 20px; flex-shrink: 0; }
.g1-toggle input { opacity: 0; width: 0; height: 0; position: absolute; }
.g1-toggle-slider {
  position: absolute;
  inset: 0;
  background: var(--c1-brd);
  border-radius: 20px;
  cursor: pointer;
  transition: background .2s;
}
.g1-toggle-slider::before {
  content: '';
  position: absolute;
  left: 2px;
  top: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  transition: transform .2s;
}
.g1-toggle input:checked + .g1-toggle-slider { background: var(--c1-dp); }
.g1-toggle input:checked + .g1-toggle-slider::before { transform: translateX(16px); }

.g1-grant-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 6px 14px 8px;
}
.g1-grant-input {
  background: #f8f8fb;
  border: 1px solid var(--c1-brd);
  color: var(--c1-t1);
  border-radius: 6px;
  padding: 7px 10px;
  font-size: .82rem;
  width: 100%;
  box-sizing: border-box;
}
.g1-grant-input:focus {
  outline: none;
  border-color: var(--c1-dp);
}

.g1-tournament-card {
  margin: 6px 14px;
  padding: 10px 12px;
}
.g1-t-name { font-size: .82rem; font-weight: 600; color: var(--c1-t1); margin-bottom: 4px; }
.g1-t-end { font-size: .75rem; color: var(--c1-muted); }
.g1-t-standing { font-size: .75rem; color: var(--c1-dp); margin-top: 4px; }

.g1-achievements-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 6px 14px 8px;
}
.g1-ach-badge {
  background: #f8f8fb;
  border: 1px solid var(--c1-brd);
  border-radius: 8px;
  padding: 10px 8px;
  text-align: center;
  cursor: default;
  transition: border-color .15s;
}
.g1-ach-badge:hover { border-color: var(--c1-dp); }
.g1-ach-icon { font-size: 1.4rem; display: block; margin-bottom: 4px; }
.g1-ach-name { font-size: .72rem; color: var(--c1-muted); }

/* ── GAME OVERLAY ──────────────────────────────────────────────────────── */
.g1-game-overlay {
  position: fixed;
  inset: 0;
  background: #f4f4f8;
  z-index: 9999;
  display: flex;
  flex-direction: column;
}
.g1-overlay-header {
  height: 48px;
  min-height: 48px;
  background: #fff;
  border-bottom: 1px solid var(--c1-brd);
  display: flex;
  align-items: center;
  padding: 0 20px;
  gap: 12px;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0,0,0,.06);
  overflow: hidden;
}
.g1-overlay-title {
  font-size: 13px;
  font-weight: 700;
  color: var(--c1-t1);
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  overflow: hidden;
  min-width: 0;
  flex-shrink: 1;
}
.g1-score-live {
  font-size: 12px;
  font-weight: 600;
  color: var(--c1-dp);
  background: rgba(124,92,252,.1);
  border-radius: 20px;
  padding: 3px 10px;
}
.g1-credits-live {
  font-size: 12px;
  font-weight: 600;
  color: #e8891c;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  flex-shrink: 0;
}
.g1-close-btn {
  background: rgba(239,68,68,.08);
  border: 1px solid rgba(239,68,68,.2);
  color: #ef4444;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: background .15s;
  white-space: nowrap;
}
.g1-close-btn:hover { background: rgba(239,68,68,.16); }
.g1-game-frame {
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  justify-content: center;
  background: #f8f9fb;
  min-height: 0;
}

.g1-game-scaler {
  display: flex;
  flex: 1;
  max-width: 700px;
  min-height: 0;
}

.g1-game-scaler > * {
  flex: 1;
  min-height: 0;
}

.g1-coming-soon {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--c1-t1, #1a1a2e);
  text-align: center;
  padding: 40px;
}

/* ── MAIN CONTENT ──────────────────────────────────────────────────────── */
.g1-content {
  padding: 20px 24px;
}

.g1-content-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.g1-content-hdr-left {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.g1-content-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--c1-t1);
}
.g1-content-sub {
  font-size: .78rem;
  color: var(--c1-muted);
}
.g1-content-hdr-right {
  display: flex;
  gap: 8px;
}

/* Loading */
.g1-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 60px 0;
  color: var(--c1-muted);
  font-size: .85rem;
}
.g1-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--c1-brd);
  border-top-color: var(--c1-dp);
  border-radius: 50%;
  animation: g1-spin 0.7s linear infinite;
}
@keyframes g1-spin { to { transform: rotate(360deg); } }

/* ── GAME GRID ─────────────────────────────────────────────────────────── */
.g1-game-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 14px;
}

.g1-grid-empty {
  grid-column: 1 / -1;
  text-align: center;
  padding: 60px 0;
}

/* ── GAME CARD ─────────────────────────────────────────────────────────── */
.c1-box {
  background: #fff;
  border: 1px solid var(--c1-brd);
  border-radius: 14px;
}

.g1-game-card {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  cursor: pointer;
  overflow: hidden;
  transition: border-color .2s, box-shadow .2s, transform .15s;
}
.g1-game-card:hover {
  border-color: var(--c1-dp);
  box-shadow: 0 6px 24px rgba(124,92,252,.14);
  transform: translateY(-3px);
}

.g1-card-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 18px 12px 14px;
  gap: 8px;
}

.g1-game-emoji {
  font-size: 2.6rem;
  line-height: 1;
  filter: drop-shadow(0 2px 6px rgba(0,0,0,0.12));
}
.g1-game-name {
  font-size: .85rem;
  font-weight: 700;
  color: var(--c1-t1);
  text-align: center;
}
.g1-game-type-tag {
  display: inline-block;
  font-size: .62rem;
  font-weight: 700;
  border: 1.5px solid;
  border-radius: 20px;
  padding: 2px 9px;
  text-transform: uppercase;
  letter-spacing: .06em;
}

.g1-card-body {
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  border-top: 1px solid var(--c1-brd-l);
}

.g1-game-stats {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.g1-my-best,
.g1-record {
  font-size: .7rem;
  color: var(--c1-muted);
}
.g1-my-best span,
.g1-record span { color: var(--c1-t1); font-weight: 600; }

.g1-rank-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: .72rem;
  font-weight: 600;
  border-radius: 10px;
  padding: 3px 8px;
  align-self: flex-start;
  border: 1px solid;
}
.g1-rank-chip.rank-gold   { border-color: #f59e0b; color: #f59e0b; background: rgba(245,158,11,.1); }
.g1-rank-chip.rank-silver { border-color: #94a3b8; color: #94a3b8; background: rgba(148,163,184,.1); }
.g1-rank-chip.rank-bronze { border-color: #cd7f32; color: #cd7f32; background: rgba(205,127,50,.1); }
.g1-rank-chip.rank-default { border-color: var(--c1-brd); color: var(--c1-muted); background: transparent; }

.rank-gold   { color: #f59e0b; }
.rank-silver { color: #94a3b8; }
.rank-bronze { color: #cd7f32; }
.rank-default { color: var(--c1-muted); }

.g1-beat-it {
  color: #f59e0b;
  font-size: .75rem;
  font-weight: 600;
  animation: g1-pulse 1.5s ease-in-out infinite;
}
@keyframes g1-pulse {
  0%, 100% { opacity: 1; }
  50%       { opacity: .5; }
}

.c1-btn-primary {
  background: var(--c1-dp);
  color: #fff;
  border: none;
  border-radius: 7px;
  padding: 8px 0;
  width: 100%;
  font-size: .8rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity .15s, background .15s;
  margin-top: auto;
  letter-spacing: .03em;
}
.c1-btn-primary:hover:not(:disabled) { opacity: .88; }
.c1-btn-primary:disabled {
  background: var(--c1-brd);
  color: var(--c1-muted);
  cursor: not-allowed;
}

/* ── MINI LEADERBOARD ON CARD ──────────────────────────────────────────── */
.g1-mini-lb {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 6px;
}
.g1-mini-lb-row {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 3px 6px;
  border-radius: 6px;
  background: var(--c1-act);
  transition: background .12s;
}
.g1-mini-lb-row:first-child { background: rgba(245,158,11,.08); }
.g1-mini-lb-row:nth-child(2) { background: rgba(148,163,184,.07); }
.g1-mini-lb-row:nth-child(3) { background: rgba(205,127,50,.07); }
.g1-mini-medal { font-size: .85rem; flex-shrink: 0; }
.g1-mini-name {
  flex: 1;
  font-size: .7rem;
  font-weight: 600;
  color: var(--c1-t1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.g1-mini-score {
  font-size: .7rem;
  font-weight: 700;
  color: var(--c1-dp);
  flex-shrink: 0;
}
.g1-no-scores {
  font-size: .68rem;
  color: var(--c1-muted);
  text-align: center;
  padding: 6px 0;
  margin-bottom: 4px;
}
.g1-card-footer {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 2px;
}
.g1-my-best-chip {
  font-size: .68rem;
  font-weight: 600;
  color: var(--c1-dp);
  background: rgba(124,92,252,.08);
  border-radius: 8px;
  padding: 2px 7px;
}

.g1-play-btn { margin-top: 4px; }

/* ── EMPTY STATES ──────────────────────────────────────────────────────── */
.g1-empty {
  font-size: .78rem;
  color: var(--c1-muted);
  padding: 16px 0;
  text-align: center;
}

/* ── RANKINGS PANEL ─────────────────────────────────────────────────────── */
.g1-credits-row {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(124,92,252,.15);
}
.g1-cred-lbl { font-size: 10px; color: var(--c1-t3); }
.g1-cred-val { font-size: 11px; font-weight: 700; color: var(--c1-dp); }

.g1-rk-section { border-bottom: 1px solid var(--c1-brd-l); }
.g1-rk-section-hdr {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  cursor: pointer;
  transition: background .12s;
}
.g1-rk-section-hdr:hover { background: var(--c1-act); }
.g1-rk-section-hdr.open { background: rgba(124,92,252,.04); }
.g1-rk-emoji { font-size: 1.1rem; flex-shrink: 0; }
.g1-rk-name { flex: 1; font-size: 12px; font-weight: 600; color: var(--c1-t1); }
.g1-rk-tag { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; }
.g1-rk-count {
  font-size: 10px;
  background: var(--c1-act);
  border-radius: 10px;
  padding: 1px 7px;
  color: var(--c1-t2);
  font-weight: 600;
}
.g1-rk-chv {
  width: 13px; height: 13px;
  stroke: var(--c1-t3); fill: none; stroke-width: 2;
  flex-shrink: 0;
  transition: transform .2s;
}
.g1-rk-body { padding: 4px 14px 12px; }
.g1-rk-play-row { margin-top: 8px; display: flex; justify-content: flex-end; }
.g1-rk-play-btn {
  background: transparent;
  border: 1px solid;
  border-radius: 20px;
  padding: 4px 14px;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity .15s;
  letter-spacing: .02em;
}
.g1-rk-play-btn:hover { opacity: .75; }

.g1-challenge-mini-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: .9rem;
  padding: 2px;
  opacity: .6;
  transition: opacity .15s;
  flex-shrink: 0;
}
.g1-challenge-mini-btn:hover { opacity: 1; }

/* ── RESPONSIVE ────────────────────────────────────────────────────────── */
@media (max-width: 767px) {
  .g1-game-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  .g1-content { padding: 12px 10px; }
  .g1-credits-chip { display: none; }
  .c1-tib-user-name { display: none; }
  .c1-tib-title { display: none; }

  /* game overlay — compact header on mobile */
  .g1-overlay-header {
    padding: 0 10px;
    gap: 8px;
  }
  .g1-credits-live { display: none; }
  .g1-close-btn {
    padding: 5px 10px;
    font-size: 10px;
  }
  .g1-close-btn + .g1-close-btn { display: none; }
  .g1-card-top { padding: 14px 8px 10px; }
  .g1-game-emoji { font-size: 2.2rem; }
  .g1-card-body { padding: 8px 10px 10px; }
}

@media (max-width: 480px) {
  .g1-game-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
  .g1-content { padding: 10px 8px; }
  .g1-card-top { padding: 12px 6px 8px; gap: 6px; }
  .g1-game-emoji { font-size: 2rem; }
  .g1-game-name { font-size: .78rem; }
  .g1-card-body { padding: 8px; gap: 5px; }
  .g1-game-scaler { max-width: 100%; }
}

/* ── Hide unified right panel (replaced by top-strip) ─ */
.c1-games-page .c1-panel:not(.g1-detail-panel) { display: none !important; }

/* ── TEAM DOT in leaderboard names ────────────────────────── */
.g1-team-dot {
  display: inline-block;
  width: 7px; height: 7px;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: middle;
  flex-shrink: 0;
}

/* ── LEADERBOARD MODE TOGGLE ───────────────────────────────── */
.g1-lb-mode-row {
  display: flex;
  gap: 4px;
  padding: 10px 14px 6px;
  border-bottom: 1px solid rgba(0,0,0,.06);
}
.g1-lb-mode-btn {
  flex: 1;
  text-align: center;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 11.5px;
  font-weight: 600;
  border: 1.5px solid rgba(0,0,0,.1);
  background: transparent;
  color: var(--c1-t2, #555);
  cursor: pointer;
  transition: all .15s;
}
.g1-lb-mode-btn.on {
  background: rgba(99,102,241,.1);
  border-color: #6366f1;
  color: #6366f1;
}
.g1-lb-mode-btn:hover:not(.on) {
  background: rgba(0,0,0,.04);
  border-color: rgba(0,0,0,.18);
}

/* ── TEAM BATTLE ────────────────────────────────────────────── */
.g1-team-battle {
  padding: 10px 0 0;
}
.g1-tb-panels {
  display: flex;
  gap: 8px;
  padding: 0 10px 10px;
}
.g1-tb-panel {
  flex: 1;
  border-radius: 10px;
  padding: 10px 8px 8px;
  border: 1.5px solid transparent;
  background: rgba(0,0,0,.025);
}
.g1-tb-panel-t1 {
  border-color: rgba(14,116,144,.35);
  background: rgba(14,116,144,.05);
}
.g1-tb-panel-t2 {
  border-color: rgba(124,58,237,.35);
  background: rgba(124,58,237,.05);
}
.g1-tb-header {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}
.g1-tb-panel-t2 .g1-tb-header {
  justify-content: flex-end;
}
.g1-tb-emoji { font-size: 1rem; }
.g1-tb-name {
  font-size: 12px;
  font-weight: 700;
  color: var(--c1-t1, #111);
}
.g1-tb-crown { font-size: .9rem; }
.g1-tb-total {
  font-size: 18px;
  font-weight: 800;
  color: var(--c1-t1, #111);
  margin-bottom: 6px;
}
.g1-tb-panel-t1 .g1-tb-total { color: #0e7490; }
.g1-tb-panel-t2 .g1-tb-total { color: #7c3aed; text-align: right; }
.g1-tb-members {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.g1-tb-member {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 10.5px;
  gap: 4px;
}
.g1-tb-member-r {
  flex-direction: row-reverse;
}
.g1-tb-member-name {
  color: var(--c1-t2, #555);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}
.g1-tb-member-score {
  font-weight: 700;
  font-size: 10px;
  color: var(--c1-t1, #111);
  white-space: nowrap;
  flex-shrink: 0;
}

/* ── BATTLE BAR ─────────────────────────────────────────────── */
.g1-battle-bar-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 10px 14px;
}
.g1-bb-label {
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
  flex-shrink: 0;
}
.g1-bb-l1 { color: #0e7490; }
.g1-bb-l2 { color: #7c3aed; }
.g1-bb-track {
  flex: 1;
  display: flex;
  height: 12px;
  border-radius: 6px;
  overflow: hidden;
  background: rgba(0,0,0,.06);
}
.g1-bb-fill-t1 {
  height: 100%;
  background: #0e7490;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  transition: width .6s cubic-bezier(.4,0,.2,1);
  min-width: 0;
}
.g1-bb-fill-t2 {
  height: 100%;
  background: #7c3aed;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: width .6s cubic-bezier(.4,0,.2,1);
  min-width: 0;
}
.g1-bb-pct {
  font-size: 8px;
  font-weight: 700;
  color: rgba(255,255,255,.9);
  padding: 0 3px;
  white-space: nowrap;
}
.g1-bb-pct-r {
  /* right side text from left */
}
</style>
